webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export app */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
  apiKey: 'AIzaSyAkHACuvyfiRldAG80-vTt38sekErJ21yk',
  authDomain: 'pei-exchange.firebaseapp.com',
  databaseURL: 'https://pei-exchange.firebaseio.com',
  storageBucket: 'pei-exchange.appspot.com',
  messagingSenderId: '999718301926'
};

var app = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);
var db = app.database();
var storage = app.storage().ref();
var auth = app.auth();



/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(705),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xNTQ5IC05MzcuNDE3IDM3LjYyMSA0NS4yODgiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICMxMDliZDQ7CiAgICAgIH0KCiAgICAgIC5jbHMtMiB7CiAgICAgICAgZmlsbDogIzMyN2NhMjsKICAgICAgfQoKICAgICAgLmNscy0zIHsKICAgICAgICBmaWxsOiAjMDBhZThmOwogICAgICB9CgogICAgICAuY2xzLTQgewogICAgICAgIGZpbGw6ICNjYTQzMmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJsb2dvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU0OSAtOTM3LjQxNykiPgogICAgPHBhdGggaWQ9IlBhdGhfMTkwNjUiIGRhdGEtbmFtZT0iUGF0aCAxOTA2NSIgY2xhc3M9ImNscy0xIiBkPSJNMzAuMTQ5LDYuMTczQTE4LjEsMTguMSwwLDEsMCwyMi42NzYsNDAuNzRoLjUyTDIzLDQ1LjI4OGgtLjM5QTIyLjY0NCwyMi42NDQsMCwwLDEsMjIuNjExLDBhMjIuMzQ3LDIyLjM0NywwLDAsMSw5LjEsMS44ODRaIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8xOTA2NiIgZGF0YS1uYW1lPSJQYXRoIDE5MDY2IiBjbGFzcz0iY2xzLTIiIGQ9Ik0yOC4xMTMsMTMuNDQ4YTE4LjM1NywxOC4zNTcsMCwwLDAtMS44ODQtLjEzLDEyLjQwOSwxMi40MDksMCwwLDAtMTIuNDEsMTIuNDEsMTIuMDc0LDEyLjA3NCwwLDAsMCwyLjE0NCw2Ljk1MmwtMy41NzQsMi42QTE2LjgxMSwxNi44MTEsMCwwLDEsMjYuMjI4LDguOWExNSwxNSwwLDAsMSwyLjQuMTk1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuMjkyIC0zLjExNykiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzE5MDY3IiBkYXRhLW5hbWU9IlBhdGggMTkwNjciIGNsYXNzPSJjbHMtMyIgZD0iTTM4LjcsNDUuNWExMi4yNzYsMTIuMjc2LDAsMCwxLTEwLjI2Niw1LjQ1OCwxMi41MjIsMTIuNTIyLDAsMCwxLTkuNDIxLTQuMjg4TDE1LjcsNDkuNTkzYTE2Ljg3NywxNi44NzcsMCwwLDAsMTIuNzM1LDUuODQ4QTE4LjMzNCwxOC4zMzQsMCwwLDAsNDMuMTIsNDguMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01LjQ5OSAtMTUuOTM2KSIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTkwNjgiIGRhdGEtbmFtZT0iUGF0aCAxOTA2OCIgY2xhc3M9ImNscy00IiBkPSJNMjIuNzI4LDI5LjAyMWE2LjY5Miw2LjY5MiwwLDEsMCw2LjY5Mi02LjY5Miw2LjY4Myw2LjY4MywwLDAsMC02LjY5Miw2LjY5Mm0tNC4wMjgsMEExMC43MjEsMTAuNzIxLDAsMSwxLDI5LjQyMSwzOS43NDIsMTAuNzMyLDEwLjczMiwwLDAsMSwxOC43LDI5LjAyMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYuNTUgLTYuNDA5KSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Tests__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Tests___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Tests__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Interested__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Interested___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Interested__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_About__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_HowItWorks__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_HowItWorks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_HowItWorks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Terms__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Login__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ForgottenPassword__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ForgottenPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_ForgottenPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Logout__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Matches__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Matches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Matches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Everyone__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Everyone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Everyone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Favourites__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Favourites___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Favourites__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Chats__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Chats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Chats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_UserProfile__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_UserProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_UserProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_CountriesExample__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_CountriesExample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_CountriesExample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Share__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_Share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Projects__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_DeleteUser__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_DeleteUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_DeleteUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_admin_Overview__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_admin_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_admin_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Register__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_EditProfile__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_EditProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_EditProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__firebase__ = __webpack_require__(3);


































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Connect, chat and exchange knowledge to drive real change in Africa',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a
  }, {
    path: '/interested',
    name: 'Interested',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Interested___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_About___default.a
  }, {
    path: '/how-it-works',
    name: 'How It Works',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_HowItWorks___default.a
  }, {
    path: '/tests',
    name: 'Tests',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Tests___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Login___default.a
  }, {
    path: '/forgot-password',
    name: 'ForgottenPassword',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_ForgottenPassword___default.a
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Logout___default.a
  }, {
    path: '/terms',
    name: 'Terms & Conditions',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Terms___default.a
  }, {
    path: '/countriesexample',
    name: 'countriesexample',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_CountriesExample___default.a
  }, {
    path: '/matches',
    name: 'Matches',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Matches___default.a
  }, {
    path: '/everyone',
    name: 'Everyone',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_Everyone___default.a
  }, {
    path: '/favourites',
    name: 'Favourites',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Favourites___default.a
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_Projects___default.a
  }, {
    path: '/itc/:id',
    name: 'Invite to Chat',
    meta: {
      inviteToChat: true
    }
  }, {
    path: '/chats',
    name: 'Chats',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Chats___default.a
  }, {
    path: '/chats/:id',
    name: 'Chat',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Chats___default.a
  }, {
    path: '/user/:slug',
    name: 'User Profile',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_UserProfile___default.a,
    meta: {
      user: true
    }
  }, {
    path: '/user/edit-profile',
    name: 'Edit Profile',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_EditProfile___default.a
  }, {
    path: '/share',
    name: 'Share',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_Share___default.a
  }, {
    path: '/delete-user',
    name: 'Delete User',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_DeleteUser___default.a
  }, {
    path: '/register/:step?',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_Register___default.a
  }, {
    path: '/admin/overview',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_admin_Overview___default.a
  }]
});

var siteName = 'PEI exChange » ';
var pageName = '';

router.beforeEach(function (to, from, next) {
  if (to.meta.user) {
    pageName = 'User Profile';
    __WEBPACK_IMPORTED_MODULE_23__firebase__["b" /* db */].ref('user-meta/slug/' + to.params.slug).once('value').then(function (s) {
      to.params.uid = s.val();
      next();
    });
  } else if (to.meta.inviteToChat) {
    __WEBPACK_IMPORTED_MODULE_23__firebase__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user) {
        router.push({ name: 'Chat', params: { id: to.params.id } });
      } else {
        router.push({ name: 'Login', params: { addtochat: to.params.id } });
      }
    });
  } else {
    pageName = to.name;
    next();
  }
  document.title = siteName + pageName;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(703),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(682),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebase__ = __webpack_require__(3);





__WEBPACK_IMPORTED_MODULE_2_es6_promise___default.a.polyfill();










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: 'UA-33080266-2',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  data: {
    user: {},
    profile: {},
    userrep: {},
    notifications: []
  },
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },
  computed: {
    testMessage: function testMessage() {
      return 'hello james';
    }
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_8__firebase__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user) {
        this.user = user;
        this.$bindAsObject('profile', __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('users/' + user.uid));
        this.$bindAsObject('profilereg', __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('users-registration/' + user.uid));
        this.$bindAsObject('userrep', __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('user-meta/reputation/' + user.uid));
        this.$bindAsArray('notifications', __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('user-meta/notifications/' + user.uid).limitToLast(10));
        __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('.info/connected').on('value', function (snapshot) {
          if (snapshot.val()) {
            __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('presence/' + user.uid).onDisconnect().set(false);
            __WEBPACK_IMPORTED_MODULE_8__firebase__["b" /* db */].ref('presence/' + user.uid).set(true);
          }
        });
      }
    }.bind(this));
  },
  watch: {
    profile: function profile(val) {
      if (val.profileimg === 'default') {
        this.profile.profileimg = 'https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f';
      }
    },
    profilereg: function profilereg(val) {
      if (val.profileimg === 'default') {
        this.profilereg.profileimg = 'https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f';
      }
    }
  }
});

app.$mount('#app');

/***/ }),
/* 286 */,
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  user: null,
  userMeta: null
};

var getters = {
  getUID: function getUID(state) {
    if (state.user) {
      return state.user.uid;
    } else {
      return null;
    }
  }
};

var mutations = {
  setUser: function setUser(state, uid) {
    state.user.uid = uid;
    state.user.loggedIn = true;
  },
  setUserMeta: function setUserMeta(state, data) {
    state.userMeta = data;
  }
};

var actions = {
  setUser: function setUser(context, uid) {
    context.commit('setUser', uid);
    __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('users/' + uid).once('value').then(function (s) {
      context.commit('setUserMeta', s.val());
    });
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(281);
  __webpack_require__(573);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_click_outside__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profile_NotificationItem__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profile_NotificationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_profile_NotificationItem__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['process', 'tooltip'],
  data: function data() {
    return {
      unreads: null,
      notificationsActive: false,
      functionsActive: false
    };
  },

  components: {
    NotificationItem: __WEBPACK_IMPORTED_MODULE_2__components_profile_NotificationItem___default.a
  },
  computed: {
    chatNotify: function chatNotify() {
      if (this.$root.profile.unreads) {
        var audio = new Audio('https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/notify-small.mp3?alt=media&token=8833aceb-1efb-4784-84c9-2d98b38b9f3a');
        audio.play();
        return true;
      } else {
        return false;
      }
    },
    unreadNotifications: function unreadNotifications() {
      var nots = this.$root.notifications;
      for (var i in nots) {
        if (nots[i].unread === true) {
          var audio = new Audio('https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/notification.mp3?alt=media&token=80dab0bd-131a-439c-8c68-e103887d5131');
          audio.play();
          return true;
        }
      }
      return false;
    },
    colorRep: function colorRep() {
      var rep = this.$root.userrep['.value'];
      var c = null;
      switch (true) {
        case rep <= 10:
          break;
        case rep <= 11 && rep <= 20:
          c = 'color-11-20';
          break;
        case rep <= 21 && rep <= 30:
          c = 'color-21-30';
          break;
        case rep <= 31 && rep <= 40:
          c = 'color-31-40';
          break;
        case rep <= 41 && rep <= 50:
          c = 'color-41-50';
          break;
        case rep <= 51 && rep <= 60:
          c = 'color-51-60';
          break;
        default:
          c = 'color-max';
          break;
      }
      return c;
    },

    showTip: function showTip() {
      if (!Array.isArray(this.$root.notifications) || !this.$root.notifications.length) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    toggleNotifications: function toggleNotifications() {
      if (this.notificationsActive) {
        var nots = this.$root.notifications;
        this.keys = [];
        for (var i in nots) {
          if (nots[i].unread === true) {
            var key = nots[i]['.key'];
            __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('user-meta/notifications/' + this.$root.user.uid + '/' + key + '/unread').remove();
          }
        }

        this.notificationsActive = false;
      } else {
        this.notificationsActive = true;
      }
    },
    hideNotifications: function hideNotifications() {
      var nots = this.$root.notifications;
      this.keys = [];
      for (var i in nots) {
        if (nots[i].unread === true) {
          var key = nots[i]['.key'];
          __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('user-meta/notifications/' + this.$root.user.uid + '/' + key + '/unread').remove();
        }
      }

      this.notificationsActive = false;
    },
    toggleFunctions: function toggleFunctions() {
      if (this.functionsActive) {
        this.functionsActive = false;
      } else {
        this.functionsActive = true;
      }
    },
    hideFunctions: function hideFunctions() {
      this.functionsActive = false;
    }
  },
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_1_vue_click_outside___default.a
  },
  mounted: function mounted() {
    this.popupItem = document.getElementById('notifications');
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['userid', 'metadisplay'],
  data: function data() {
    return {
      userData: {},
      userRep: {}
    };
  },

  methods: {
    removeFavourite: function removeFavourite(userid) {
      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.$root.user.uid + '/favourites/' + userid).remove();
    },
    removeMatch: function removeMatch(userid) {
      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.$root.user.uid + '/hidden-users').update(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.userid, true));
    }
  },
  created: function created() {
    this.userData = {};
    this.userRep = {};
    this.$bindAsObject('userData', __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.userid));
    this.$bindAsObject('userRep', __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('user-meta/reputation/' + this.userid));
  },
  watch: {
    userData: function userData(val) {
      if (val.profileimg === 'default') {
        this.userData.profileimg = 'https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f';
      }
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UserBox__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UserBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UserBox__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  components: {
    UserBox: __WEBPACK_IMPORTED_MODULE_0__components_UserBox___default.a
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Options__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Options___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Options__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_naming_FirstName__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_naming_FirstName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_chat_naming_FirstName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_naming_FullName__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_naming_FullName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_chat_naming_FullName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(23);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Conversation',
  data: function data() {
    return {
      message: '',
      chat: {
        lastUpdated: null,
        lastMessage: null
      }
    };
  },

  props: ['id', 'after'],
  firebase: function firebase() {
    return {
      messages: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-messages/' + this.id),
      members: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-members/' + this.id),
      unreads: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats/' + this.id + '/unreads'),
        asObject: true
      }
    };
  },

  components: {
    Message: __WEBPACK_IMPORTED_MODULE_1__Message___default.a,
    Options: __WEBPACK_IMPORTED_MODULE_2__Options___default.a,
    FirstName: __WEBPACK_IMPORTED_MODULE_3__components_chat_naming_FirstName___default.a,
    FullName: __WEBPACK_IMPORTED_MODULE_4__components_chat_naming_FullName___default.a
  },
  methods: {
    send: function send() {
      if (this.message !== '') {
        var timestamp = Date.now();
        this.$firebaseRefs.messages.push({
          user: this.$root.user.uid,
          content: this.message,
          createdAt: timestamp
        });
        var unreads = {};
        for (var index in this.members) {
          unreads[this.members[index]['.key']] = this.unreads[this.members[index]['.key']] + 1;

          if (this.members[index]['.key'] !== this.$root.user.uid) {
            __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.members[index]['.key'] + '/unreads').set(1);
          }
        }
        unreads[this.$root.user.uid] = 0;

        this.$firebaseRefs.chat.set({
          lastMessage: this.$root.profile.firstname + ': ' + this.message,
          lastUpdated: timestamp,
          unreads: unreads
        });
        this.message = '';
      } else {
        alert('Please type a message.');
      }
      this.message = '';
    },
    scrollToEnd: function scrollToEnd() {
      var container = this.$el.querySelector('#conversation');
      container.scrollTop = container.scrollHeight;
    },
    isMember: function isMember() {
      for (var index in this.members) {
        if (this.members[index]['.key'] === this.$root.user.uid) {
          return true;
        }
      }
      return false;
    },
    growBox: function growBox(box) {
      box.style.height = 0;
      box.style.height = box.scrollHeight + 'px';
    }
  },
  updated: function updated() {
    if (this.chat && this.chat.lastUpdated) {
      if (this.chat.lastUpdated < this.after) {
        __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/chats');
      }
      if (this.$root.user) {
        this.$firebaseRefs.unreads.child(this.$root.user.uid).set(0);
        if (!this.isMember()) {
          __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/chats');
        }
      }
      this.scrollToEnd();
    }
  },

  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user) {
        this.$bindAsObject('chat', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats/' + this.id));
      }
    }.bind(this));
  },
  watch: {
    'id': function id(current, previous) {
      this.$bindAsObject('chat', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats/' + current));
      this.$bindAsArray('messages', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-messages/' + current));
      this.$bindAsArray('members', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-members/' + current));
      this.$bindAsObject('unreads', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats/' + current + '/unreads'));
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GiveReputation',
  props: ['member'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Invite',
  props: ['chatID'],
  data: function data() {
    return {
      keywords: '',
      email: 'email@address.com',
      invitationList: []
    };
  },
  firebase: function firebase() {
    return {
      results: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users'),
      members: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-members/' + this.chatID),
        asObject: true
      }
    };
  },

  methods: {
    addToList: function addToList(uid) {
      if (this.invitationList.indexOf(uid) !== -1) {
        this.invitationList.splice(this.invitationList.indexOf(uid), 1);
      } else {
        this.invitationList.push(uid);
      }
    },
    invite: function invite() {
      if (this.invitationList.length < 1) {
        alert('Please select people to invite.');
      } else {
        var updates = {};
        var timestamp = Date.now();
        for (var index in this.invitationList) {
          updates['chats/' + this.chatID + '/unreads/' + this.invitationList[index]] = 0;
          updates['chats-members/' + this.chatID + '/' + this.invitationList[index]] = true;
          updates['users-chats/' + this.invitationList[index] + '/' + this.chatID] = {
            createdAt: 0 - timestamp,
            showAfter: 0 - timestamp
          };
        }
        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref().update(updates);
        this.$parent.invite = false;
      }
    }
  },
  watch: {
    'keywords': function keywords(current, previous) {
      if (current.length > 0) {
        this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users').orderByChild('firstname').startAt(current).endAt(current + '\uF8FF'));
      } else {
        this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users'));
      }
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



var dateFormat = __webpack_require__(63);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Message',
  props: ['message', 'index', 'allmessages'],
  data: function data() {
    return {
      dateFormat: dateFormat
    };
  },
  firebase: function firebase() {
    return {
      from: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.message.user),
        asObject: true
      }
    };
  },

  computed: {
    continuedMessage: function continuedMessage() {
      if (this.allmessages[this.index - 1]) {
        if (this.allmessages[this.index - 1].user === this.message.user) {
          return true;
        }
      } else {
        return false;
      }
    },
    finalMessage: function finalMessage() {
      if (this.allmessages[this.index + 1]) {
        if (this.allmessages[this.index + 1].user === this.message.user && !this.continuedMessage) {
          return true;
        }
      } else {
        return false;
      }
    },
    showWhen: function showWhen() {
      var now = Date.now();
      var diff = now - this.message.createdAt;
      if (diff < 900000) {
        return false;
      } else if (this.continuedMessage) {
        return false;
      } else {
        return true;
      }
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MultipleMembers',
  props: ['member'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      }
    };
  },

  methods: {
    remove: function remove() {
      console.log(this.user['.key']);
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-chats/' + this.user['.key'] + '/' + this.$route.params.id).remove();
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats/' + this.$route.params.id + '/unreads/' + this.user['.key']).remove();
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-members/' + this.$route.params.id + '/' + this.user['.key']).remove();
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Invite__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Invite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Invite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SingleMember__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SingleMember___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SingleMember__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MultipleMembers__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MultipleMembers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MultipleMembers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GiveReputation__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GiveReputation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GiveReputation__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Options',
  props: ['chatID'],
  data: function data() {
    return {
      invite: false
    };
  },

  components: {
    Invite: __WEBPACK_IMPORTED_MODULE_1__Invite___default.a,
    SingleMember: __WEBPACK_IMPORTED_MODULE_2__SingleMember___default.a,
    MultipleMembers: __WEBPACK_IMPORTED_MODULE_3__MultipleMembers___default.a,
    GiveReputation: __WEBPACK_IMPORTED_MODULE_4__GiveReputation___default.a
  },
  methods: {
    deleteChat: function deleteChat() {
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-chats/' + this.$root.user.uid + '/' + this.chatID + '/showAfter').set(Date.now());
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SingleMember',
  props: ['member'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      },
      rep: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('user-meta/reputation/' + this.member),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_naming_FullNameList__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_naming_FullNameList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_chat_naming_FullNameList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_naming_FirstNameList__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_naming_FirstNameList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_chat_naming_FirstNameList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_list_ProfilePicture__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_list_ProfilePicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_chat_list_ProfilePicture__);






var dateFormat = __webpack_require__(63);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Item',
  props: ['id', 'after'],
  data: function data() {
    return {
      dateFormat: dateFormat,
      chat: {
        lastMessage: null,
        lastUpdated: null
      },
      unreads: 0
    };
  },

  components: {
    FullNameList: __WEBPACK_IMPORTED_MODULE_1__components_chat_naming_FullNameList___default.a,
    FirstNameList: __WEBPACK_IMPORTED_MODULE_2__components_chat_naming_FirstNameList___default.a,
    ProfilePicture: __WEBPACK_IMPORTED_MODULE_3__components_chat_list_ProfilePicture___default.a
  },
  firebase: function firebase() {
    return {
      chat: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats/' + this.id),
        asObject: true
      },
      unreads: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats/' + this.id + '/unreads/' + this.$root.user.uid),
        asObject: true
      },
      members: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-members/' + this.id)
    };
  },

  methods: {
    read: function read() {}
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_list_Item__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_list_Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_chat_list_Item__);



var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',
  props: ['chats'],
  data: function data() {
    return {
      moment: moment
    };
  },

  components: {
    Item: __WEBPACK_IMPORTED_MODULE_0__components_chat_list_Item___default.a
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfilePicture',
  props: ['member', 'index', 'total'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FirstName',
  props: ['member', 'deli', 'showDeli', 'presence'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      },
      online: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('presence/' + this.member),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FirstName',
  props: ['member', 'deli', 'showDeli', 'presence'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      },
      online: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('presence/' + this.member),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FullName',
  props: ['member', 'deli', 'showDeli', 'presence'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      },
      online: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('presence/' + this.member),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FullName',
  props: ['member', 'deli', 'showDeli', 'presence'],
  firebase: function firebase() {
    return {
      user: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.member),
        asObject: true
      },
      online: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('presence/' + this.member),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(23);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'New',
  data: function data() {
    return {
      message: '',
      members: [],
      keywords: '',
      results: [],
      chatID: null,
      oldChatMembers: null
    };
  },

  watch: {
    'keywords': function keywords(current, previous) {
      if (current.length > 1) {
        current.toLowerCase();
        this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users').orderByChild('searchterm').startAt(current).endAt(current + '\uF8FF'));
      } else {
        this.results = [];
      }
    }
  },
  methods: {
    add: function add(user) {
      if (user['.key'] !== this.$root.user.uid) {
        this.members.push(user);
        this.keywords = '';
      }
    },
    remove: function remove(index) {
      this.members.splice(index, 1);
    },
    send: function send() {
      if (this.members.length === 0) {
        alert('Please add members to this chat.');
      } else if (this.message === '') {
        alert('Please type a message.');
      } else {
        var oldChatID = null;
        if (this.members.length === 1) {
          console.log(this.$parent.chats);
          for (var chatsIndex in this.$parent.chats) {
            console.log(chatsIndex + ': ' + this.$parent.chats[chatsIndex]['.key']);
            this.$bindAsArray('oldChatMembers', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-members/' + this.$parent.chats[chatsIndex]['.key']));
            if (this.oldChatMembers.length === 2) {
              console.log('Two members chat');
              for (var chatMembersIndex in this.oldChatMembers) {
                console.log(chatMembersIndex);
                if (this.oldChatMembers[chatMembersIndex]['.key'] === this.members[0]['.key']) {
                  console.log('Same chat member found!');
                  oldChatID = this.$parent.chats[chatsIndex]['.key'];
                  console.log('Push to: ' + oldChatID);
                  break;
                }
              }
            }
            if (oldChatID) {
              break;
            }
          }
        }

        if (oldChatID) {
          this.chatID = oldChatID;
        } else {
          this.chatID = __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats').push().key;
        }
        var updates = {};
        var timestamp = Date.now();

        var unreads = {};
        for (var index in this.members) {
          unreads[this.members[index]['.key']] = 1;
        }
        unreads[this.$root.user.uid] = 0;

        updates['/chats/' + this.chatID] = {
          lastMessage: this.$root.profile.firstname + ': ' + this.message,
          lastUpdated: timestamp,
          unreads: unreads
        };

        if (!oldChatID) {
          updates['/chats-members/' + this.chatID] = {};
          for (index in this.members) {
            updates['/chats-members/' + this.chatID][this.members[index]['.key']] = true;
          }
          updates['/chats-members/' + this.chatID][this.$root.user.uid] = true;

          for (index in this.members) {
            updates['/users-chats/' + this.members[index]['.key'] + '/' + this.chatID] = {
              createdAt: 0 - timestamp,
              showAfter: timestamp
            };
          }
          updates['/users-chats/' + this.$root.user.uid + '/' + this.chatID] = {
            createdAt: 0 - timestamp,
            showAfter: timestamp
          };
          updates['/chats-messages/' + this.chatID] = [{
            content: this.message,
            user: this.$root.user.uid,
            createdAt: timestamp
          }];
        } else {
          updates['/chats-messages/' + this.chatID + '/-new'] = {
            content: this.message,
            user: this.$root.user.uid,
            createdAt: timestamp
          };
        }
        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref().update(updates);
        this.message = '';
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/chats/' + this.chatID);
      }
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(23);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['userid', 'firstname', 'surname'],
  data: function data() {
    return {
      reportReason: '',
      now: Date.now()
    };
  },

  methods: {
    closeOverlay: function closeOverlay() {
      this.$parent.showBlockOverlay = false;
    },
    reportUser: function reportUser() {
      var user = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* auth */].currentUser;
      if (user) {
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + user.uid + '/blocked-users').update(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.userid, true));

        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('reports/reported-users').push({
          reportedUser: this.userid,
          reason: this.reportReason,
          reportedBy: user.uid,
          when: this.now
        }, function () {
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/matches');
        });
      }
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profile_Message__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profile_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profile_Message__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['chats', 'userid'],
  data: function data() {
    return {
      members: null,
      fbmessages: null
    };
  },

  components: {
    Message: __WEBPACK_IMPORTED_MODULE_1__components_profile_Message___default.a
  },
  computed: {
    chatID: function chatID() {
      for (var index in this.chats) {
        var key = this.chats[index]['.key'];
        this.$bindAsArray('members', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-members/' + key));
        if (this.members.length === 2) {
          for (var i in this.members) {
            if (this.members[i]['.key'] !== this.$root.user.uid) {
              if (this.members[i]['.key'] === this.userid) {
                console.log;
                this.$parent.chatID = key;
                return key;
              }
            }
          }
        }
      }
    },
    messages: function messages() {
      if (this.chatID) {
        this.$bindAsArray('fbmessages', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('chats-messages/' + this.chatID));
        return this.fbmessages;
      }
    }
  },
  methods: {
    scrollToEnd: function scrollToEnd() {
      var container = document.querySelector('#chatter');
      container.scrollTop = container.scrollHeight;
    }
  },
  updated: function updated() {
    this.scrollToEnd();
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['itemid'],
  firebase: function firebase() {
    return {
      itemData: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/countries/' + this.itemid),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['itemid'],
  firebase: function firebase() {
    return {
      itemData: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/focus-areas/' + this.itemid),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



var dateFormat = __webpack_require__(63);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Message',
  props: ['message', 'index', 'allmessages'],
  data: function data() {
    return {
      dateFormat: dateFormat
    };
  },
  firebase: function firebase() {
    return {
      from: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.message.user),
        asObject: true
      }
    };
  },

  computed: {
    continuedMessage: function continuedMessage() {
      if (this.allmessages[this.index - 1]) {
        if (this.allmessages[this.index - 1].user === this.message.user) {
          return true;
        }
      } else {
        return false;
      }
    },
    finalMessage: function finalMessage() {
      if (this.allmessages[this.index + 1]) {
        if (this.allmessages[this.index + 1].user === this.message.user && !this.continuedMessage) {
          return true;
        }
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['senderid', 'message', 'when', 'unread', 'link'],
  firebase: function firebase() {
    return {
      userData: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.senderid),
        asObject: true
      }
    };
  },
  computed: {
    dateShow: function dateShow() {
      var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.when).fromNow();
      return date;
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['itemid'],
  firebase: function firebase() {
    return {
      itemData: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills/' + this.itemid),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profile_Skill__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profile_Skill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_profile_Skill__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data'],
  components: {
    Skill: __WEBPACK_IMPORTED_MODULE_0__components_profile_Skill___default.a
  },
  data: function data() {
    return {
      swiperOption: {
        paginationClickable: true,
        nextButton: '.slide-next',
        prevButton: '.slide-prev',
        spaceBetween: 17,
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    };
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['itemid', 'itemname', 'itemimg', 'itemclass'],
  computed: {
    isActive: function isActive() {
      if (this.$parent.selectedItems.indexOf(this.itemid) > -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    toggleItem: function toggleItem() {
      if (this.$parent.selectedItems.indexOf(this.itemid) > -1) {
        console.log('item exists');
        var index = this.$parent.selectedItems.indexOf(this.itemid);
        console.log(index);
        this.$parent.selectedItems.splice(index, 1);
        this.$parent.selectedItemTags.splice(index, 1);
      } else {
        console.log('Item doesnt exist');
        this.$parent.selectedItems.push(this.itemid);
        this.$parent.selectedItemTags.push({ 'name': this.itemname, 'id': this.itemid });
      }
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_croppie__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_croppie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_croppie__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['imgUrl'],
  data: function data() {
    return {
      image: this.$parent.imageToUpload,
      croppie: null
    };
  },

  methods: {
    setUpCroppie: function setUpCroppie() {
      var el = document.getElementById('croppie');
      this.$parent.croppie = new __WEBPACK_IMPORTED_MODULE_0_croppie___default.a(el, {
        viewport: { width: 300, height: 300, type: 'circle' },
        boundary: { width: 340, height: 340 },
        showZoomer: true,
        mouseWheelZoom: false
      });
      this.$parent.croppie.bind({
        url: this.image
      });
    },
    addPhoto: function addPhoto() {
      this.$refs.fileInput.click();
    },
    setUpFileUploader: function setUpFileUploader(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.image = e.target.result;
        vm.$emit('imageUploaded', e.target.result);
      };
      reader.readAsDataURL(file);
    }
  },
  mounted: function mounted() {
    this.$on('imageUploaded', function (imageData) {
      this.image = imageData;
      if (this.$parent.croppie) {
        this.$parent.croppie.destroy();
      }
      this.setUpCroppie(imageData);
    });
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data', 'items'],
  data: function data() {
    return {
      centeredSlides: 'false',
      swiperOption: {
        paginationClickable: true,
        nextButton: '.slide-next',
        prevButton: '.slide-prev',
        spaceBetween: 10,
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    };
  },

  methods: {
    removeTag: function removeTag(id, name) {
      var index = this.$parent.selectedItems.indexOf(id);
      this.$parent.selectedItems.splice(index, 1);
      this.$parent.selectedItemTags.splice(index, 1);
    }
  },
  computed: {
    noOfSlides: function noOfSlides() {
      var slides = this.items;
      if (slides > 3) {
        slides = 3;
      }
      if (slides > 1) {
        this.centeredSlides = 'true';
      } else {
        this.centeredSlides = 'false';
      }
      return slides;
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_list_List__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_list_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_chat_list_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_conversation_Conversation__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_chat_conversation_Conversation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_chat_conversation_Conversation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_new_New__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_new_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_chat_new_New__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chats',
  data: function data() {
    return {
      chats: [],
      current: this.$route.params.id,
      chat: {}
    };
  },
  firebase: function firebase() {
    return {
      chat: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-chats/' + this.$root.user.uid + '/' + this.current),
        asObject: true
      }
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    List: __WEBPACK_IMPORTED_MODULE_2__components_chat_list_List___default.a,
    Conversation: __WEBPACK_IMPORTED_MODULE_3__components_chat_conversation_Conversation___default.a,
    New: __WEBPACK_IMPORTED_MODULE_4__components_chat_new_New___default.a
  },
  watch: {
    '$route': function $route(current, previous) {
      this.current = current.params.id;
      if (current.params.id) {
        this.$bindAsObject('chat', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-chats/' + this.$root.user.uid + '/' + current.params.id));
      } else {
        this.chat = {};
      }
    }
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.$root.user.uid + '/unreads').set(0);
    __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user) {
        this.$bindAsArray('chats', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-chats/' + user.uid).orderByChild('createdAt'));
        this.$bindAsObject('chat', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-chats/' + user.uid + '/' + this.current));
      }
    }.bind(this));
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profile_Country__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profile_Country___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_profile_Country__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      favourited: null
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    Country: __WEBPACK_IMPORTED_MODULE_2__components_profile_Country___default.a
  },
  firebase: function firebase() {
    return {
      countries: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/countries'),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Matches',
  props: ['personality'],
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a
  },
  data: function data() {
    return {
      userid: 'CacCUlrjf9WOIJD4InWIBAzP5qE3',
      userdata: null,
      userchats: null
    };
  },


  methods: {
    deleteUser: function deleteUser() {
      if (this.userid) {
        this.$bindAsObject('userdata', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users').child(this.userid));
        this.$bindAsObject('userchats', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-chats').child(this.userid));
      }
    }
  },
  watch: {
    userdata: function userdata(val) {
      if (val['.key']) {
        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('user-meta/reputation/' + this.userid).remove();

        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('user-meta/notifications/' + this.userid).remove();

        if (val.slug) {
          __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('user-meta/slug/' + val.slug).remove();
        }

        if (val.personality['have-skills']) {
          for (var item1 in val.personality['have-skills']) {
            __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills/' + item1 + '/users/' + this.userid).remove();
          }
          for (var item2 in val.personality['want-skills']) {
            __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills/' + item2 + '/users/' + this.userid).remove();
          }
        }

        for (var item3 in val.personality['focus-areas']) {
          __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/focus-areas/' + item3 + '/users/' + this.userid).remove();
        }

        for (var item4 in val.personality['countries']) {
          __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/countries/' + item4 + '/users/' + this.userid).remove();
        }

        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.userid).remove();

        alert('User Removed');
      }
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_edit_profile_BigIdea__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_edit_profile_BigIdea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_edit_profile_BigIdea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_edit_profile_UserMeta__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_edit_profile_UserMeta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_edit_profile_UserMeta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_edit_profile_FocusAreas__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_edit_profile_FocusAreas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_edit_profile_FocusAreas__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BigIdea: __WEBPACK_IMPORTED_MODULE_0__pages_edit_profile_BigIdea___default.a,
    UserMeta: __WEBPACK_IMPORTED_MODULE_1__pages_edit_profile_UserMeta___default.a,
    FocusAreas: __WEBPACK_IMPORTED_MODULE_2__pages_edit_profile_FocusAreas___default.a
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserRow__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_UserRow__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Matches',
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    UserRow: __WEBPACK_IMPORTED_MODULE_2__components_UserRow___default.a
  },
  data: function data() {
    return {
      queryText: '',
      results: []
    };
  },

  watch: {
    queryText: function queryText(val) {
      this.results = [];
      var term = val.toLowerCase();
      this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users').orderByChild('searchterm').startAt(term).endAt(term + '\uF8FF'));
    }
  },
  created: function created() {
    this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users').orderByChild('searchterm'));
  },

  computed: {
    uiHideInstructions: function uiHideInstructions() {
      if (this.$root.profile['ui-meta']) {
        if (this.$root.profile['ui-meta'].hideEveryoneInstructions) {
          return true;
        }
      } else {
        return false;
      }
    },
    userIds: function userIds() {
      var arr = [];
      this.results.forEach(function (user) {
        arr.push(user['.key']);
      });
      return arr;
    },
    filterUsers: function filterUsers() {
      var arr = [];
      var blockedArr = [];
      var blockedObj = this.$root.profile['blocked-users'];
      for (var item in blockedObj) {
        blockedArr.push(item);
      }
      this.results.forEach(function (user) {
        var uid = user['.key'];
        if (blockedArr.indexOf(uid) > -1) {} else if (user['firstname'] === undefined) {} else if (user['disabled']) {} else {
          arr.push(uid);
        }
      });
      return arr;
    },
    chunkArray: function chunkArray() {
      var chunks = [];
      var arr = this.filterUsers;
      var i = void 0;
      var chunkSize = 6;
      if (arr) {
        for (i = 0; i < arr.length; i += chunkSize) {
          chunks.push(arr.slice(i, i + chunkSize));
        }
      }
      return chunks;
    }
  },
  methods: {
    hideInstructions: function hideInstructions() {
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.$root.user.uid + '/ui-meta').update({
        hideEveryoneInstructions: true
      }, function () {
        console.log('hidden the instructions');
      });
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserBox__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_UserBox__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Matches',
  props: ['favourites'],
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    UserBox: __WEBPACK_IMPORTED_MODULE_2__components_UserBox___default.a
  },
  firebase: function firebase() {
    return {
      fbUsers: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/'),
        asObject: true
      }
    };
  },
  computed: {
    uiHideInstructions: function uiHideInstructions() {
      if (this.$root.profile['ui-meta']) {
        if (this.$root.profile['ui-meta'].hideFavouritesInstructions) {
          return true;
        }
      } else {
        return false;
      }
    },
    favouritesArray: function favouritesArray() {
      if (!this.favourites) {
        return [];
      } else {
        var arr = [];
        for (var item in this.favourites) {
          arr.push(item);
        }
        return arr;
      }
    },
    chunkArray: function chunkArray() {
      var chunks = [];
      var arr = this.favouritesArray;
      if (arr) {
        var i = void 0;
        var chunkSize = 4;

        for (i = 0; i < arr.length; i += chunkSize) {
          chunks.push(arr.slice(i, i + chunkSize));
        }
      }
      return chunks;
    },
    chunkArrayLength: function chunkArrayLength() {
      if (this.chunkArray.length) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    hideInstructions: function hideInstructions() {
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users/' + this.$root.user.uid + '/ui-meta').update({
        hideFavouritesInstructions: true
      }, function () {
        console.log('hidden the instructions');
      });
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      resetComplete: false
    };
  },

  methods: {
    forgotPassword: function forgotPassword() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].sendPasswordResetEmail(this.email).then(function () {
        parent.resetComplete = true;
      }, function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register',
  data: function data() {
    return {
      email: '',
      added: false,
      now: Date.now()
    };
  },

  methods: {
    register: function register() {
      if (this.email) {
        var parent = this;

        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('pre-registration').push({
          email: this.email,
          when: this.now
        }, function () {
          parent.added = true;
        });
      } else {
        console.error('no email given');
      }
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dateformat__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dateformat__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Interested',
  firebase: function firebase() {
    return {
      preReg: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('pre-registration')
      }
    };
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_dateformat___default()(date, 'h:MM:ss TT - dS mmmm yyyy');
    }
  },
  computed: {
    bccLink: function bccLink() {
      var string = 'mailto:?bcc=';
      for (var item in this.preReg) {
        string = string + this.preReg[item].email + ',';
      }
      return string;
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(23);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      hasPasswordError: false,
      hasEmailError: false,
      passwordMessage: '************',
      emailMessage: 'someone@example.com',
      addtochat: this.$route.params.addtochat
    };
  },

  methods: {
    login: function login() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        console.log(user.uid);
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('matches');
      }).catch(function (err) {
        console.log(err.code);
        if (err.code === 'auth/wrong-password') {
          parent.password = '';
          parent.hasPasswordError = true;
          parent.passwordMessage = 'Password incorrect. Please try again.';
        }
        if (err.code === 'auth/user-not-found') {
          parent.email = '';
          parent.password = '';
          parent.hasEmailError = true;
          parent.emailMessage = 'This user does not exist. Try again.';
        }
        if (err.code === 'auth/too-many-requests') {
          parent.email = '';
          parent.password = '';
          parent.hasEmailError = true;
          parent.emailMessage = 'Too many login attempts. Try again later.';
        }
      });
    },
    resetError: function resetError() {
      this.hasPasswordError = false;
      this.hasEmailError = false;
      this.passwordMessage = '************';
      this.emailMessage = 'someone@example.com';
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(23);





/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].signOut().then(function () {
        localStorage.clear();

        console.log('Logged out');
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/login');
        }, 1000);
      }, function (error) {
        console.error(error);
      });
    }
  },
  mounted: function mounted() {
    this.logout();
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UserBox__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UserBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_UserBox__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Matches',
  props: ['personality'],
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar___default.a,
    UserBox: __WEBPACK_IMPORTED_MODULE_3__components_UserBox___default.a
  },
  data: function data() {
    return {
      matches: {}
    };
  },

  firebase: function firebase() {
    return {
      fbUsers: {
        source: __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/'),
        asObject: false
      }
    };
  },
  computed: {
    uiHideInstructions: function uiHideInstructions() {
      if (this.$root.profile['ui-meta']) {
        if (this.$root.profile['ui-meta'].hideMatchesInstructions) {
          return true;
        }
      } else {
        return false;
      }
    },
    matchedUsers: function matchedUsers() {
      if (!this.personality) {
        return [];
      } else {
        var arr = [];

        var wantSkills = this.personality['want-skills'];
        var haveSkills = this.personality['have-skills'];
        var focusAreas = this.personality['focus-areas'];

        this.matchCheck(wantSkills, 'skills', 20);
        this.matchCheck(haveSkills, 'skills', 10);
        this.matchCheck(focusAreas, 'focus-areas', 5);

        var len = 0;

        for (var o in this.matches) {
          len++;
        }

        if (len < 8) {
          var extras = 8 - len;
          this.extraUsers(extras, 1);
        }

        for (var item in this.matches) {
          if (item !== this.$root.user.uid) {
            arr.push(item);
          }
        }

        return arr;
      }
    },
    chunkArray: function chunkArray() {
      var chunks = [];
      var arr = this.matchedUsers;
      var i = void 0;
      var chunkSize = 4;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      chunks.length = 3;
      return chunks;
    }
  },
  methods: {
    hideInstructions: function hideInstructions() {
      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.$root.user.uid + '/ui-meta').update({
        hideMatchesInstructions: true
      }, function () {
        console.log('hidden the instructions');
      });
    },
    matchCheck: function matchCheck(items, dbSection, points) {
      var _this = this;

      var _loop = function _loop(attrId) {
        var parent = _this;

        var ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/' + dbSection + '/' + attrId + '/users');

        return {
          v: ref.once('value').then(function (s) {
            s.forEach(function (user) {
              var uid = user.key;
              if (!parent.matches[uid]) {
                parent.matches[uid] = 0;
              }
              parent.matches[uid] = parent.matches[uid] + points;
            });
          })
        };
      };

      for (var attrId in items) {
        var _ret = _loop(attrId);

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    extraUsers: function extraUsers(noOfExtras, points) {
      var parent = this;
      var ref = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/');

      return ref.limitToFirst(noOfExtras).once('value').then(function (s) {
        s.forEach(function (user) {
          var uid = user.key;
          if (!parent.matches[uid]) {
            parent.matches[uid] = 0;
          }
          parent.matches[uid] = parent.matches[uid] + points;
        });
      });
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mailchimp_v3__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mailchimp_v3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mailchimp_v3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mailchimp: __WEBPACK_IMPORTED_MODULE_0_mailchimp_v3___default.a
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a
  },
  methods: {
    testMailchimp: function testMailchimp() {
      __WEBPACK_IMPORTED_MODULE_0_mailchimp_v3___default.a.setApiKey('d6a20355664643f51fa850ed860f42c7-us15');
      __WEBPACK_IMPORTED_MODULE_0_mailchimp_v3___default.a.get('lists').then(function (lists) {
        console.log(lists);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_register_Register_Step_1__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_register_Register_Step_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_register_Register_Step_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_register_Register_Step_2__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_register_Register_Step_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_register_Register_Step_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_register_Register_Step_3__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_register_Register_Step_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_register_Register_Step_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_register_Register_Step_4__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_register_Register_Step_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_register_Register_Step_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_register_Register_Step_5__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_register_Register_Step_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_register_Register_Step_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_register_Register_Step_6__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_register_Register_Step_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_register_Register_Step_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_register_Register_Step_7__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_register_Register_Step_7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_register_Register_Step_7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_register_Register_Step_8__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_register_Register_Step_8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_register_Register_Step_8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_register_Register_Step_9__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_register_Register_Step_9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_register_Register_Step_9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_register_Register_Step_10__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_register_Register_Step_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_register_Register_Step_10__);














/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentStep: 1,
      dbStep: null,

      email: '',

      firstname: '',
      surname: '',
      organisation: '',
      sector: '',
      jobtitle: '',
      location: '',

      bigIdea: '',
      selectedCountries: [],
      selectedCountriesTags: []
    };
  },

  components: {
    RegisterStep1: __WEBPACK_IMPORTED_MODULE_1__pages_register_Register_Step_1___default.a,
    RegisterStep2: __WEBPACK_IMPORTED_MODULE_2__pages_register_Register_Step_2___default.a,
    RegisterStep3: __WEBPACK_IMPORTED_MODULE_3__pages_register_Register_Step_3___default.a,
    RegisterStep4: __WEBPACK_IMPORTED_MODULE_4__pages_register_Register_Step_4___default.a,
    RegisterStep5: __WEBPACK_IMPORTED_MODULE_5__pages_register_Register_Step_5___default.a,
    RegisterStep6: __WEBPACK_IMPORTED_MODULE_6__pages_register_Register_Step_6___default.a,
    RegisterStep7: __WEBPACK_IMPORTED_MODULE_7__pages_register_Register_Step_7___default.a,
    RegisterStep8: __WEBPACK_IMPORTED_MODULE_8__pages_register_Register_Step_8___default.a,
    RegisterStep9: __WEBPACK_IMPORTED_MODULE_9__pages_register_Register_Step_9___default.a,
    RegisterStep10: __WEBPACK_IMPORTED_MODULE_10__pages_register_Register_Step_10___default.a
  },
  created: function created() {
    var step = this.$route.params.step;
    var intstep = step.replace('step-', '');
    this.currentStep = parseInt(intstep);
  },
  watch: {
    currentStep: function currentStep(val) {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].replace('/register/step-' + val);
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_HeaderBar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar___default.a
  },
  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },
    progress: function progress() {
      var userData = this.userRegData;
      var timestamp = Date.now();
      delete userData['.key'];

      var focusArea = userData.personality['focus-areas'];
      var haveSkills = userData.personality['have-skills'];
      var countries = userData.personality['countries'];
      var userObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.$root.user.uid, true);
      var userSlug = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, userData.slug, this.$root.user.uid);

      if (focusArea) {
        for (var item in focusArea) {
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/focus-areas/' + item + '/users').update(userObj);
        }
      }

      if (haveSkills) {
        for (var _item in haveSkills) {
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/skills/' + _item + '/users').update(userObj);
        }
      }

      if (countries) {
        for (var _item2 in countries) {
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/countries/' + _item2 + '/users').update(userObj);
        }
      }

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('user-meta/slug').update(userSlug);

      var parent = this;
      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.$root.user.uid).set(userData, function () {
        console.log('saved');
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users-registration/' + parent.$root.user.uid).remove();
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/matches');
      });

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('user-meta/notifications/' + this.$root.user.uid).push({
        from: 'pei',
        content: 'Thanks for signing up! Here\'s +5 rep as a warm welcome!',
        createdAt: timestamp
      });
    }
  },
  firebase: function firebase() {
    return {
      itemData: {
        source: __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/skills/')
      },
      userRegData: {
        source: __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users-registration/' + this.$root.user.uid),
        asObject: true
      }
    };
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      testVariable: "d6a20355664643f51fa850ed860f42c7-us15"
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a
  },
  mounted: function mounted() {},

  methods: {
    testMailchimp: function testMailchimp() {},
    addData: function addData() {
      var list = ['Arabic', 'Bengali/Sylhetti', 'Russian', 'Japanese', 'Javanese', 'Malay/Indonesian', 'German', 'Italian', 'Korean', 'Dutch', 'Swedish', 'Finnish', 'Polish', 'Swahili', 'Afrikaans', 'Akan', 'Amharic', 'Berber', 'Chewa', 'Mauritian Creole', 'Fulani', 'Gikuyu', 'Hausa', 'Igbo', 'Kinyarwanda', 'Kirundi', 'Kongo', 'Lingala', 'Luo', 'Malagasy', 'Mossi', 'Ndebele', 'Northern Sotho', 'Oromo', 'Sesotho', 'Shilha', 'Shona', 'Somali', 'Swahili', 'Tigrinya', 'Tshiluba', 'Tswana', 'Umbundu', 'Yoruba', 'Xhosa', 'Zulu', 'Lahnda', 'Telugu', 'Marati', 'Turkish', 'Tamil', 'Vietnamise', 'Translation'];
      for (var index in list) {
        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills').push({
          category: 'Languages',
          name: list[index],
          searchterm: list[index].toLowerCase(),
          img: '/'
        });
      }
      alert('Done!');
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profile_FocusArea__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profile_FocusArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profile_FocusArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile_Skill__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile_Skill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_profile_Skill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profile_Country__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profile_Country___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_profile_Country__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profile_Chat__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profile_Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_profile_Chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profile_BlockReport__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profile_BlockReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_profile_BlockReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profile_Slider__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profile_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_profile_Slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dateformat__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dateformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_backgrounds_1_jpg__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_backgrounds_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_backgrounds_1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_backgrounds_2_jpg__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_backgrounds_2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_backgrounds_2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_backgrounds_3_jpg__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_backgrounds_3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_backgrounds_3_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_backgrounds_4_jpg__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_backgrounds_4_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_backgrounds_4_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_backgrounds_5_jpg__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_backgrounds_5_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_backgrounds_5_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_backgrounds_6_jpg__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_backgrounds_6_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_backgrounds_6_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_backgrounds_7_jpg__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_backgrounds_7_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_backgrounds_7_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_backgrounds_8_jpg__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_backgrounds_8_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_backgrounds_8_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_backgrounds_9_jpg__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_backgrounds_9_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_backgrounds_9_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_backgrounds_10_jpg__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_backgrounds_10_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_backgrounds_10_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_backgrounds_11_jpg__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_backgrounds_11_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_backgrounds_11_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_backgrounds_12_jpg__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_backgrounds_12_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_backgrounds_12_jpg__);




























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Matches',
  props: ['thisuser', 'favourites'],
  data: function data() {
    return {
      favourited: null,
      chatActive: false,
      message: '',
      chatID: null,
      chats: [],
      showOptionsOverlay: false,
      showBlockOverlay: false
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar___default.a,
    FocusArea: __WEBPACK_IMPORTED_MODULE_3__components_profile_FocusArea___default.a,
    Skill: __WEBPACK_IMPORTED_MODULE_4__components_profile_Skill___default.a,
    Country: __WEBPACK_IMPORTED_MODULE_5__components_profile_Country___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_8__components_profile_Slider___default.a,
    Chat: __WEBPACK_IMPORTED_MODULE_6__components_profile_Chat___default.a,
    BlockReport: __WEBPACK_IMPORTED_MODULE_7__components_profile_BlockReport___default.a
  },
  computed: {
    currentUser: function currentUser() {
      if (this.$route.params.uid === this.$root.user.uid) {
        return true;
      } else {
        return false;
      }
    },
    background: function background() {
      var random = Math.floor(Math.random() * 11) + 1;
      var arr = [__WEBPACK_IMPORTED_MODULE_10__assets_images_backgrounds_1_jpg___default.a, __WEBPACK_IMPORTED_MODULE_11__assets_images_backgrounds_2_jpg___default.a, __WEBPACK_IMPORTED_MODULE_12__assets_images_backgrounds_3_jpg___default.a, __WEBPACK_IMPORTED_MODULE_13__assets_images_backgrounds_4_jpg___default.a, __WEBPACK_IMPORTED_MODULE_14__assets_images_backgrounds_5_jpg___default.a, __WEBPACK_IMPORTED_MODULE_15__assets_images_backgrounds_6_jpg___default.a, __WEBPACK_IMPORTED_MODULE_16__assets_images_backgrounds_7_jpg___default.a, __WEBPACK_IMPORTED_MODULE_17__assets_images_backgrounds_8_jpg___default.a, __WEBPACK_IMPORTED_MODULE_18__assets_images_backgrounds_9_jpg___default.a, __WEBPACK_IMPORTED_MODULE_19__assets_images_backgrounds_10_jpg___default.a, __WEBPACK_IMPORTED_MODULE_20__assets_images_backgrounds_11_jpg___default.a, __WEBPACK_IMPORTED_MODULE_21__assets_images_backgrounds_12_jpg___default.a];
      return arr[random];
    },
    userJoined: function userJoined() {
      var joined = __WEBPACK_IMPORTED_MODULE_9_dateformat___default()(this.user.joined, 'dS mmmm yyyy');
      return joined;
    },
    hasIdea: function hasIdea() {
      var bigIdea = this.user.bigidea;
      if (bigIdea) {
        return true;
      } else {
        return false;
      }
    },
    focusAreas: function focusAreas() {
      if (this.user.personality) {
        var focusAreas = this.user.personality['focus-areas'];
        return focusAreas;
      } else {
        return {};
      }
    },
    hasSkills: function hasSkills() {
      if (this.user.personality) {
        var hasSkills = this.user.personality['have-skills'];
        return hasSkills;
      } else {
        return {};
      }
    },
    wantSkills: function wantSkills() {
      if (this.user.personality) {
        var wantSkills = this.user.personality['want-skills'];
        return wantSkills;
      } else {
        return {};
      }
    },
    countries: function countries() {
      if (this.user.personality) {
        var countries = this.user.personality['countries'];
        return countries;
      } else {
        return {};
      }
    },
    isFavourited: function isFavourited() {
      if (this.favourites) {
        if (this.$route.params.uid in this.favourites) {
          this.favourited = true;
          return true;
        }
      } else {
        this.favourited = false;
        return false;
      }
    }
  },
  methods: {
    favouriteUser: function favouriteUser() {
      var favData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.$route.params.uid, true);
      if (this.favourited) {
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.thisuser.uid + '/favourites/' + this.$route.params.uid).remove();
      } else {
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.thisuser.uid + '/favourites').update(favData);
      }
    },
    toggleChat: function toggleChat() {
      if (this.chatActive) {
        this.chatActive = false;
      } else {
        this.chatActive = true;
      }
    },
    openOptions: function openOptions() {
      this.showOptionsOverlay = true;
    },
    closeOptions: function closeOptions(e) {
      if (e.target.tagName !== 'A') {
        this.showOptionsOverlay = false;
      }
    },
    blockUser: function blockUser() {
      alert('blocked');
    },
    blockAndReportUser: function blockAndReportUser() {
      this.showOptionsOverlay = false;
      this.showBlockOverlay = true;
    },
    openChat: function openChat() {
      this.chatActive = true;
    },
    send: function send() {
      if (this.message !== '') {
        var timestamp = Date.now();
        if (this.chatID) {
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('chats-messages/' + this.chatID).push({
            user: this.$root.user.uid,
            content: this.message,
            createdAt: timestamp
          });
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.$route.params.uid + '/unreads').set(1);
          var unreads = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.$route.params.uid, 1);
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('chats/' + this.chatID).set({
            lastMessage: this.$root.profile.firstname + ': ' + this.message,
            lastUpdated: timestamp,
            unreads: unreads
          });
        } else {
          var _db$ref$set;

          var opr = __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('chats').push();
          var key = opr.key;
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('chats-messages/' + key).push({
            user: this.$root.user.uid,
            content: this.message,
            createdAt: timestamp
          });
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.$route.params.uid + '/unreads').set(1);
          var _unreads2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.$route.params.uid, 1);
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('chats/' + key).set({
            lastMessage: this.$root.profile.firstname + ': ' + this.message,
            lastUpdated: timestamp,
            unreads: _unreads2
          });
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users-chats/' + this.$root.user.uid + '/' + key).set({
            createdAt: 0 - timestamp,
            showAfter: timestamp
          });
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('chats-members/' + key).set((_db$ref$set = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_db$ref$set, this.$root.user.uid, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_db$ref$set, this.$route.params.uid, true), _db$ref$set));
        }
        this.message = '';
      } else {
        alert('Please type a message.');
      }
    }
  },
  updated: function updated() {
    var container = document.querySelector('#chatter');
    container.scrollTop = container.scrollHeight;
  },
  beforeCreate: function beforeCreate() {
    this.$bindAsObject('userID', __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('user-meta/slug').child(this.$route.params.uid));
    this.$bindAsObject('user', __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users').child(this.$route.params.uid));
    this.$bindAsObject('userRep', __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('user-meta/reputation').child(this.$route.params.uid));
  },
  mounted: function mounted() {
    var title = document.title;
    var thisuser = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* auth */].currentUser;
    var thisuserid = thisuser.uid;
    this.$bindAsArray('chats', __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users-chats/' + thisuserid).orderByChild('createdAt'));
    title = title.replace('User Profile', this.user.firstname + ' ' + this.user.surname);
    document.title = title;
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Admin',
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a
  },
  data: function data() {
    return {};
  },

  firebase: function firebase() {
    return {
      users: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users')
      },
      presence: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('presence').orderByValue().equalTo(true)
      }
    };
  },
  computed: {
    noOfUsers: function noOfUsers() {
      if (this.users) {
        return this.users.length;
      }
    },
    onlineUsers: function onlineUsers() {
      if (this.presence) {
        return this.presence.length;
      }
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(23);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bigIdea: this.$root.profile.bigidea
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default.a
  },
  methods: {
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(window.history.back());
    },
    save: function save() {
      var user = this.$root.user.uid;
      if (this.bigIdea) {
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + user).update({
          bigidea: this.bigIdea
        }, function () {
          console.log('saved');
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(window.history.back());
        });
      } else {
        alert('Unable to save. Please try again.');
      }
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_register_PickerItem__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_register_PickerItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_register_PickerItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_Slider__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_register_Slider__);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedItems: [],
      selectedItemTags: []
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_3__components_HeaderBar___default.a,
    PickerItem: __WEBPACK_IMPORTED_MODULE_4__components_register_PickerItem___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_5__components_register_Slider___default.a
  },
  methods: {
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(window.history.back());
    },
    save: function save() {
      var focusData = {};
      var user = this.$root.user.uid;

      for (var i = 0; i < this.selectedItems.length; ++i) {
        focusData[this.selectedItems[i]] = true;
        var userData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, user, true);
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/focus-areas/' + this.selectedItems[i] + '/users').update(userData);
      }

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + user + '/personality/focus-areas').set(focusData, function () {
        console.log('saved');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].go(window.history.back());
      });
    }
  },
  firebase: function firebase() {
    return {
      focusAreas: {
        source: __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/focus-areas/')
      }
    };
  },
  computed: {
    chunkArray: function chunkArray() {
      var chunks = [];
      var arr = this.focusAreas;
      var i = void 0;
      var chunkSize = 4;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    noOfItems: function noOfItems() {
      return this.selectedItems.length;
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_titlecase__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_titlecase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_titlecase__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      firstname: this.$root.profile.firstname,
      surname: this.$root.profile.surname,
      organisation: this.$root.profile.organisation,
      website: this.$root.profile.website,
      location: this.$root.profile.location,
      jobtitle: this.$root.profile.jobtitle
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a
  },
  methods: {
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(window.history.back());
    },
    save: function save() {
      var user = this.$root.user.uid;
      var oldSlug = this.$root.profile.slug;

      var slug = this.firstname + '-' + this.surname;
      var saveSlug = slug.toLowerCase();

      var searchterm = this.firstname + ' ' + this.surname;
      var saveSearchTerm = searchterm.toLowerCase();

      __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('user-meta/slug/' + oldSlug).remove();
      var userSlug = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, saveSlug, user);
      __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('user-meta/slug').update(userSlug);

      __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('users/' + user).update({
        firstname: __WEBPACK_IMPORTED_MODULE_4_titlecase___default()(this.firstname),
        surname: __WEBPACK_IMPORTED_MODULE_4_titlecase___default()(this.surname),
        organisation: __WEBPACK_IMPORTED_MODULE_4_titlecase___default()(this.organisation),
        website: this.website,
        jobtitle: __WEBPACK_IMPORTED_MODULE_4_titlecase___default()(this.jobtitle),
        location: __WEBPACK_IMPORTED_MODULE_4_titlecase___default()(this.location),
        slug: saveSlug,
        searchterm: saveSearchTerm
      }, function () {
        console.log('saved');
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push(saveSlug);
      });
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register',
  data: function data() {
    return {
      email: '',
      message: '',
      hasError: false
    };
  },

  methods: {
    register: function register() {
      console.log(this.email);
      if (this.email) {
        document.getElementsByTagName('input').disabled = true;
        var parent = this;
        var newPassword = Math.random().toString(36).slice(-8);
        __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].createUserWithEmailAndPassword(this.email, newPassword).then(function (user) {
          console.log(user.uid);
          parent.$parent.currentStep++;
        }).catch(function (err) {
          document.getElementsByTagName('input').disabled = false;
          console.log(err.code);
          parent.message = err.message;
          parent.hasError = true;
        });
      } else {
        console.error('no email given');
      }
    }
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].signOut().then(function () {
      console.log('Logged out');
    }, function (error) {
      console.error(error);
    });
  },

  watch: {
    email: function email(val) {
      this.hasError = false;
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HeaderBar__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_2__components_HeaderBar___default.a
  },
  methods: {
    save: function save() {
      console.log('Save initiated');
      var userData = this.userRegData;
      var timestamp = Date.now();
      delete userData['.key'];

      var focusArea = userData.personality['focus-areas'];
      var haveSkills = userData.personality['have-skills'];
      var countries = userData.personality['countries'];
      var userObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.$root.user.uid, true);
      var userSlug = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, userData.slug, this.$root.user.uid);

      if (focusArea) {
        for (var item in focusArea) {
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/focus-areas/' + item + '/users').update(userObj);
        }
      }

      if (haveSkills) {
        for (var _item in haveSkills) {
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/skills/' + _item + '/users').update(userObj);
        }
      }

      if (countries) {
        for (var _item2 in countries) {
          __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('attributes/countries/' + _item2 + '/users').update(userObj);
        }
      }

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('user-meta/slug').update(userSlug);

      var parent = this;
      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users/' + this.$root.user.uid).set(userData, function () {
        console.log('saved');
        __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users-registration/' + parent.$root.user.uid).remove();
      });

      __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('user-meta/notifications/' + this.$root.user.uid).push({
        from: 'pei',
        content: 'Thanks for signing up! Enjoy exploring!',
        createdAt: timestamp
      });
    }
  },
  firebase: function firebase() {
    return {
      userRegData: {
        source: __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* db */].ref('users-registration/' + this.$root.user.uid),
        asObject: true
      }
    };
  },
  mounted: function mounted() {
    this.save();
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register',
  data: function data() {
    return {
      password: '',
      confirmPassword: '',
      message: '',
      isSuccess: false,
      hasError: false
    };
  },

  methods: {
    register: function register() {
      document.getElementsByTagName('input').disabled = true;
      if (this.password === this.confirmPassword) {
        this.hasError = false;
        this.message = '';
        var parent = this;
        var user = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].currentUser;
        user.updatePassword(this.password).then(function () {
          parent.isSuccess = true;

          parent.$parent.currentStep++;
        }, function (error) {
          document.getElementsByTagName('input').disabled = false;
          console.error(error.message);
          parent.message = error.message;
          parent.isSuccess = false;
          parent.hasError = true;
        });
      } else {
        console.error('Passwords dont match');
        this.message = 'Please make sure both passwords match.';
        this.isSuccess = false;
        this.hasError = true;
      }
    }
  },
  watch: {
    password: function password(val) {
      this.hasError = false;
    },
    confirmPassword: function confirmPassword(val) {
      this.hasError = false;
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_titlecase__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_titlecase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_titlecase__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register',
  data: function data() {
    return {
      now: Date.now()
    };
  },

  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },
    register: function register() {
      if (this.formComplete) {
        var parent = this;
        var user = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].currentUser;

        var slug = this.$parent.firstname + '-' + this.$parent.surname;
        var saveSlug = slug.toLowerCase();

        var searchterm = this.$parent.firstname + ' ' + this.$parent.surname;
        var saveSearchTerm = searchterm.toLowerCase();

        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user.uid).update({
          firstname: __WEBPACK_IMPORTED_MODULE_1_titlecase___default()(this.$parent.firstname),
          surname: __WEBPACK_IMPORTED_MODULE_1_titlecase___default()(this.$parent.surname),
          organisation: __WEBPACK_IMPORTED_MODULE_1_titlecase___default()(this.$parent.organisation),
          sector: this.$parent.sector,
          jobtitle: __WEBPACK_IMPORTED_MODULE_1_titlecase___default()(this.$parent.jobtitle),
          location: __WEBPACK_IMPORTED_MODULE_1_titlecase___default()(this.$parent.location),
          joined: this.now,
          slug: saveSlug,
          searchterm: saveSearchTerm,
          email: this.$root.user.email
        }, function () {
          parent.$parent.currentStep++;
        });
      }
    }
  },
  computed: {
    formComplete: function formComplete() {
      var p = this.$parent;
      if (p.firstname && p.surname && p.organisation && p.location && p.jobtitle) {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_register_ProfileImage__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_register_ProfileImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_register_ProfileImage__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register',
  data: function data() {
    return {
      imageToUpload: null,
      croppie: null
    };
  },

  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },
    progress: function progress() {
      var _this = this;

      var user = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* auth */].currentUser;
      if (!this.croppie) {
        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user.uid).update({
          profileimg: 'default'
        });
      } else {
        this.croppie.result({
          type: 'blob',
          size: { width: 500, height: 500 },
          quality: 0.6,
          circle: false,
          format: 'jpeg'
        }).then(function (response) {
          console.log(response);
          _this.imageToUpload = response;
          var uploadTask = __WEBPACK_IMPORTED_MODULE_0__firebase__["c" /* storage */].child('profile-images/' + user.uid);
          uploadTask.put(response).then(function (snapshot) {
            var profileimg = snapshot.downloadURL;
            __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user.uid).update({
              profileimg: profileimg
            });
          });
        });
      }

      var parent = this;
      var repData = {};
      repData[user.uid] = 5;
      console.log(repData);
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('user-meta/reputation/').update(repData, function () {
        console.log('saved');
        parent.$parent.currentStep++;
      });
    }
  },
  components: {
    ProfileImage: __WEBPACK_IMPORTED_MODULE_1__components_register_ProfileImage___default.a
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_register_Slider__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedItems: [],
      selectedItemTags: []
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    PickerItem: __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default.a
  },
  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },
    progress: function progress() {
      var focusData = {};
      var user = this.$root.user.uid;

      for (var i = 0; i < this.selectedItems.length; ++i) {
        focusData[this.selectedItems[i]] = true;
      }
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user + '/personality/focus-areas').set(focusData, function () {
        console.log('saved');
        parent.$parent.currentStep++;
      });
    }
  },
  firebase: function firebase() {
    return {
      focusAreas: {
        source: __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/focus-areas/')
      }
    };
  },
  computed: {
    chunkArray: function chunkArray() {
      var chunks = [];
      var arr = this.focusAreas;
      var i = void 0;
      var chunkSize = 4;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    noOfItems: function noOfItems() {
      return this.selectedItems.length;
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_register_Slider__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedItems: [],
      selectedItemTags: [],
      queryText: '',
      noOfItems: null,
      countries: [],
      showCen: true,
      showNor: false,
      showEas: false,
      showSou: false,
      showWes: false
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    PickerItem: __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default.a
  },
  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },

    chunkMethod: function chunkMethod(items) {
      var chunks = [];
      var arr = items;
      var i = void 0;
      var chunkSize = 6;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    toggleGroup: function toggleGroup(dataId) {
      if (this[dataId] === true) {
        this[dataId] = false;
      } else {
        this.showCen = false;
        this.showNor = false;
        this.showEas = false;
        this.showSou = false;
        this.showWes = false;
        this[dataId] = true;
      }
    },
    progress: function progress() {
      var itemData = {};

      for (var i = 0; i < this.selectedItems.length; ++i) {
        itemData[this.selectedItems[i]] = true;
      }
      console.log(itemData);

      var user = this.$root.user.uid;
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user + '/personality/countries').set(itemData, function () {
        console.log('saved');
        parent.$parent.currentStep++;
      });
    },
    removeTag: function removeTag(id, name) {
      this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
      this.selectedItemTags.splice(this.selectedItemTags.indexOf(name), 1);
    }
  },
  computed: {
    CentralCountries: function CentralCountries() {
      if (this.countries) {
        var arr = this.countries.filter(function (el) {
          return el.region === 'Central';
        });
        if (!this.queryText) {
          var index = arr.map(function (o) {
            return o['.key'];
          }).indexOf('whole-Central');
          var front = arr.splice(index, 1);
          arr.unshift(front[0]);
        }
        return this.chunkMethod(arr);
      }
    },
    NorthCountries: function NorthCountries() {
      if (this.countries) {
        var arr = this.countries.filter(function (el) {
          return el.region === 'North';
        });
        if (!this.queryText) {
          var index = arr.map(function (o) {
            return o['.key'];
          }).indexOf('whole-North');
          var front = arr.splice(index, 1);
          arr.unshift(front[0]);
        }
        return this.chunkMethod(arr);
      }
    },
    EastCountries: function EastCountries() {
      if (this.countries) {
        var arr = this.countries.filter(function (el) {
          return el.region === 'East';
        });
        if (!this.queryText) {
          var index = arr.map(function (o) {
            return o['.key'];
          }).indexOf('whole-East');
          var front = arr.splice(index, 1);
          arr.unshift(front[0]);
        }
        return this.chunkMethod(arr);
      }
    },
    SouthCountries: function SouthCountries() {
      if (this.countries) {
        var arr = this.countries.filter(function (el) {
          return el.region === 'South';
        });
        if (!this.queryText) {
          var index = arr.map(function (o) {
            return o['.key'];
          }).indexOf('whole-South');
          var front = arr.splice(index, 1);
          arr.unshift(front[0]);
        }
        return this.chunkMethod(arr);
      }
    },
    WestCountries: function WestCountries() {
      if (this.countries) {
        var arr = this.countries.filter(function (el) {
          return el.region === 'West';
        });
        if (!this.queryText) {
          var index = arr.map(function (o) {
            return o['.key'];
          }).indexOf('whole-West');
          var front = arr.splice(index, 1);
          arr.unshift(front[0]);
        }
        return this.chunkMethod(arr);
      }
    },
    showTip: function showTip() {
      if (!Array.isArray(this.selectedItems) || !this.selectedItems.length) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    queryText: function queryText(val) {
      var term = val.toLowerCase();
      if (term !== '') {
        this.showCen = true;
        this.showNor = true;
        this.showEas = true;
        this.showSou = true;
        this.showWes = true;
      } else {
        this.showCen = false;
        this.showNor = false;
        this.showEas = false;
        this.showSou = false;
        this.showWes = false;
      }
      term = term.charAt(0).toUpperCase() + term.slice(1);
      this.$bindAsArray('countries', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/countries').orderByChild('name').startAt(term).endAt(term + '\uF8FF'));
    }
  },
  mounted: function mounted() {
    this.$bindAsArray('countries', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/countries').orderByChild('name'));
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_register_Slider__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedItems: [],
      selectedItemTags: [],
      queryText: '',
      results: [],
      showGov: true,
      showCom: false,
      showBus: false,
      showDes: false,
      showLea: false,
      showAna: false,
      showTec: false,
      showLeg: false,
      showSte: false
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    PickerItem: __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default.a
  },
  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },
    progress: function progress() {
      var itemData = {};

      var user = this.$root.user.uid;
      for (var i = 0; i < this.selectedItems.length; ++i) {
        itemData[this.selectedItems[i]] = true;
      }

      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user + '/personality/have-skills').set(itemData, function () {
        console.log('saved');
        parent.$parent.currentStep++;
      });
    },
    removeTag: function removeTag(id, name) {
      this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
      this.selectedItemTags.splice(this.selectedItemTags.indexOf(name), 1);
    },

    chunkMethod: function chunkMethod(items) {
      var chunks = [];
      var arr = items;
      var i = void 0;
      var chunkSize = 6;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    toggleGroup: function toggleGroup(dataId) {
      if (this[dataId] === true) {
        this[dataId] = false;
      } else {
        this.showGov = false;
        this.showCom = false;
        this.showBus = false;
        this.showDes = false;
        this.showLea = false;
        this.showAna = false;
        this.showTec = false;
        this.showLeg = false;
        this.showSte = false;
        this[dataId] = true;
      }
    }
  },
  computed: {
    chunkArray: function chunkArray() {
      var chunks = [];
      var arr = this.results;
      var i = void 0;
      var chunkSize = 6;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    govAndIntDevSkills: function govAndIntDevSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Governance and International Development';
      });
      return this.chunkMethod(arr);
    },
    commsSkills: function commsSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Communications';
      });
      return this.chunkMethod(arr);
    },
    businessSkills: function businessSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Business';
      });
      return this.chunkMethod(arr);
    },
    designSkills: function designSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Design and Creativity';
      });
      return this.chunkMethod(arr);
    },
    leadershipSkills: function leadershipSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Leadership and Management';
      });
      return this.chunkMethod(arr);
    },
    analyticSkills: function analyticSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Analysis and Research';
      });
      return this.chunkMethod(arr);
    },
    techSkills: function techSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Technical and Information Skills';
      });
      return this.chunkMethod(arr);
    },
    languageSkills: function languageSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Languages';
      });
      return this.chunkMethod(arr);
    },
    legalSkills: function legalSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Legal';
      });
      return this.chunkMethod(arr);
    },
    stemSkills: function stemSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'STEM';
      });
      return this.chunkMethod(arr);
    }
  },
  watch: {
    queryText: function queryText(val) {
      var term = val.toLowerCase();
      if (term !== '') {
        this.showGov = true;
        this.showCom = true;
        this.showBus = true;
        this.showDes = true;
        this.showLea = true;
        this.showAna = true;
        this.showTec = true;
        this.showLeg = true;
        this.showSte = true;
      } else {
        this.showGov = false;
        this.showCom = false;
        this.showBus = false;
        this.showDes = false;
        this.showLea = false;
        this.showAna = false;
        this.showTec = false;
        this.showLeg = false;
        this.showSte = false;
      }
      this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills/').orderByChild('searchterm').startAt(term).endAt(term + '\uF8FF'));
    }
  },
  mounted: function mounted() {
    this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills/').orderByChild('searchterm'));
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Register',
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a
  },
  data: function data() {
    return {
      bigIdea: this.bigIdea
    };
  },

  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },
    progress: function progress() {
      var parent = this;
      var user = this.$root.user.uid;
      this.$parent.bigIdea = this.bigIdea;

      if (this.$parent.bigIdea) {
        __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user).update({
          bigidea: this.$parent.bigIdea
        }, function () {
          console.log('saved');
          parent.$parent.currentStep++;
        });
      } else {
        this.$parent.currentStep++;
      }
    },
    addExample: function addExample() {
      var example = 'My big idea for Africa is to use mobile technology and micro-finance to empower women in rural areas and enable them to uplift their families from endemic poverty.';
      this.bigIdea = example;
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_register_Slider__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedItems: [],
      selectedItemTags: [],
      queryText: '',
      results: [],
      showGov: true,
      showCom: false,
      showBus: false,
      showDes: false,
      showLea: false,
      showAna: false,
      showTec: false,
      showLeg: false,
      showSte: false
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components_HeaderBar___default.a,
    PickerItem: __WEBPACK_IMPORTED_MODULE_2__components_register_PickerItem___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_3__components_register_Slider___default.a
  },
  methods: {
    stepBack: function stepBack() {
      this.$parent.currentStep--;
    },

    chunkMethod: function chunkMethod(items) {
      var chunks = [];
      var arr = items;
      var i = void 0;
      var chunkSize = 6;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    toggleGroup: function toggleGroup(dataId) {
      if (this[dataId] === true) {
        this[dataId] = false;
      } else {
        this.showGov = false;
        this.showCom = false;
        this.showBus = false;
        this.showDes = false;
        this.showLea = false;
        this.showAna = false;
        this.showTec = false;
        this.showLeg = false;
        this.showSte = false;
        this[dataId] = true;
      }
    },
    progress: function progress() {
      var itemData = {};

      for (var i = 0; i < this.selectedItems.length; ++i) {
        itemData[this.selectedItems[i]] = true;
      }
      console.log(itemData);

      var user = this.$root.user.uid;
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('users-registration/' + user + '/personality/want-skills').set(itemData, function () {
        console.log('saved');
        parent.$parent.currentStep++;
      });
    },
    removeTag: function removeTag(id, name) {
      this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
      this.selectedItemTags.splice(this.selectedItemTags.indexOf(name), 1);
    }
  },
  computed: {
    chunkArray: function chunkArray() {
      var chunks = [];
      var arr = this.results;
      var i = void 0;
      var chunkSize = 6;

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    },
    govAndIntDevSkills: function govAndIntDevSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Governance and International Development';
      });
      return this.chunkMethod(arr);
    },
    commsSkills: function commsSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Communications';
      });
      return this.chunkMethod(arr);
    },
    businessSkills: function businessSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Business';
      });
      return this.chunkMethod(arr);
    },
    designSkills: function designSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Design and Creativity';
      });
      return this.chunkMethod(arr);
    },
    leadershipSkills: function leadershipSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Leadership and Management';
      });
      return this.chunkMethod(arr);
    },
    analyticSkills: function analyticSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Analysis and Research';
      });
      return this.chunkMethod(arr);
    },
    techSkills: function techSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Technical and Information Skills';
      });
      return this.chunkMethod(arr);
    },
    languageSkills: function languageSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Languages';
      });
      return this.chunkMethod(arr);
    },
    legalSkills: function legalSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'Legal';
      });
      return this.chunkMethod(arr);
    },
    stemSkills: function stemSkills() {
      var arr = this.results.filter(function (el) {
        return el.category === 'STEM';
      });
      return this.chunkMethod(arr);
    }
  },
  watch: {
    queryText: function queryText(val) {
      var term = val.toLowerCase();
      if (term !== '') {
        this.showGov = true;
        this.showCom = true;
        this.showBus = true;
        this.showDes = true;
        this.showLea = true;
        this.showAna = true;
        this.showTec = true;
        this.showLeg = true;
        this.showSte = true;
      } else {
        this.showGov = false;
        this.showCom = false;
        this.showBus = false;
        this.showDes = false;
        this.showLea = false;
        this.showAna = false;
        this.showTec = false;
        this.showLeg = false;
        this.showSte = false;
      }
      this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills/').orderByChild('searchterm').startAt(term).endAt(term + '\uF8FF'));
    }
  },
  mounted: function mounted() {
    this.$bindAsArray('results', __WEBPACK_IMPORTED_MODULE_0__firebase__["b" /* db */].ref('attributes/skills/').orderByChild('searchterm'));
  }
});

/***/ }),
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 165,
	"./af.js": 165,
	"./ar": 172,
	"./ar-dz": 166,
	"./ar-dz.js": 166,
	"./ar-kw": 167,
	"./ar-kw.js": 167,
	"./ar-ly": 168,
	"./ar-ly.js": 168,
	"./ar-ma": 169,
	"./ar-ma.js": 169,
	"./ar-sa": 170,
	"./ar-sa.js": 170,
	"./ar-tn": 171,
	"./ar-tn.js": 171,
	"./ar.js": 172,
	"./az": 173,
	"./az.js": 173,
	"./be": 174,
	"./be.js": 174,
	"./bg": 175,
	"./bg.js": 175,
	"./bn": 176,
	"./bn.js": 176,
	"./bo": 177,
	"./bo.js": 177,
	"./br": 178,
	"./br.js": 178,
	"./bs": 179,
	"./bs.js": 179,
	"./ca": 180,
	"./ca.js": 180,
	"./cs": 181,
	"./cs.js": 181,
	"./cv": 182,
	"./cv.js": 182,
	"./cy": 183,
	"./cy.js": 183,
	"./da": 184,
	"./da.js": 184,
	"./de": 187,
	"./de-at": 185,
	"./de-at.js": 185,
	"./de-ch": 186,
	"./de-ch.js": 186,
	"./de.js": 187,
	"./dv": 188,
	"./dv.js": 188,
	"./el": 189,
	"./el.js": 189,
	"./en-au": 190,
	"./en-au.js": 190,
	"./en-ca": 191,
	"./en-ca.js": 191,
	"./en-gb": 192,
	"./en-gb.js": 192,
	"./en-ie": 193,
	"./en-ie.js": 193,
	"./en-nz": 194,
	"./en-nz.js": 194,
	"./eo": 195,
	"./eo.js": 195,
	"./es": 197,
	"./es-do": 196,
	"./es-do.js": 196,
	"./es.js": 197,
	"./et": 198,
	"./et.js": 198,
	"./eu": 199,
	"./eu.js": 199,
	"./fa": 200,
	"./fa.js": 200,
	"./fi": 201,
	"./fi.js": 201,
	"./fo": 202,
	"./fo.js": 202,
	"./fr": 205,
	"./fr-ca": 203,
	"./fr-ca.js": 203,
	"./fr-ch": 204,
	"./fr-ch.js": 204,
	"./fr.js": 205,
	"./fy": 206,
	"./fy.js": 206,
	"./gd": 207,
	"./gd.js": 207,
	"./gl": 208,
	"./gl.js": 208,
	"./gom-latn": 209,
	"./gom-latn.js": 209,
	"./he": 210,
	"./he.js": 210,
	"./hi": 211,
	"./hi.js": 211,
	"./hr": 212,
	"./hr.js": 212,
	"./hu": 213,
	"./hu.js": 213,
	"./hy-am": 214,
	"./hy-am.js": 214,
	"./id": 215,
	"./id.js": 215,
	"./is": 216,
	"./is.js": 216,
	"./it": 217,
	"./it.js": 217,
	"./ja": 218,
	"./ja.js": 218,
	"./jv": 219,
	"./jv.js": 219,
	"./ka": 220,
	"./ka.js": 220,
	"./kk": 221,
	"./kk.js": 221,
	"./km": 222,
	"./km.js": 222,
	"./kn": 223,
	"./kn.js": 223,
	"./ko": 224,
	"./ko.js": 224,
	"./ky": 225,
	"./ky.js": 225,
	"./lb": 226,
	"./lb.js": 226,
	"./lo": 227,
	"./lo.js": 227,
	"./lt": 228,
	"./lt.js": 228,
	"./lv": 229,
	"./lv.js": 229,
	"./me": 230,
	"./me.js": 230,
	"./mi": 231,
	"./mi.js": 231,
	"./mk": 232,
	"./mk.js": 232,
	"./ml": 233,
	"./ml.js": 233,
	"./mr": 234,
	"./mr.js": 234,
	"./ms": 236,
	"./ms-my": 235,
	"./ms-my.js": 235,
	"./ms.js": 236,
	"./my": 237,
	"./my.js": 237,
	"./nb": 238,
	"./nb.js": 238,
	"./ne": 239,
	"./ne.js": 239,
	"./nl": 241,
	"./nl-be": 240,
	"./nl-be.js": 240,
	"./nl.js": 241,
	"./nn": 242,
	"./nn.js": 242,
	"./pa-in": 243,
	"./pa-in.js": 243,
	"./pl": 244,
	"./pl.js": 244,
	"./pt": 246,
	"./pt-br": 245,
	"./pt-br.js": 245,
	"./pt.js": 246,
	"./ro": 247,
	"./ro.js": 247,
	"./ru": 248,
	"./ru.js": 248,
	"./sd": 249,
	"./sd.js": 249,
	"./se": 250,
	"./se.js": 250,
	"./si": 251,
	"./si.js": 251,
	"./sk": 252,
	"./sk.js": 252,
	"./sl": 253,
	"./sl.js": 253,
	"./sq": 254,
	"./sq.js": 254,
	"./sr": 256,
	"./sr-cyrl": 255,
	"./sr-cyrl.js": 255,
	"./sr.js": 256,
	"./ss": 257,
	"./ss.js": 257,
	"./sv": 258,
	"./sv.js": 258,
	"./sw": 259,
	"./sw.js": 259,
	"./ta": 260,
	"./ta.js": 260,
	"./te": 261,
	"./te.js": 261,
	"./tet": 262,
	"./tet.js": 262,
	"./th": 263,
	"./th.js": 263,
	"./tl-ph": 264,
	"./tl-ph.js": 264,
	"./tlh": 265,
	"./tlh.js": 265,
	"./tr": 266,
	"./tr.js": 266,
	"./tzl": 267,
	"./tzl.js": 267,
	"./tzm": 269,
	"./tzm-latn": 268,
	"./tzm-latn.js": 268,
	"./tzm.js": 269,
	"./uk": 270,
	"./uk.js": 270,
	"./ur": 271,
	"./ur.js": 271,
	"./uz": 273,
	"./uz-latn": 272,
	"./uz-latn.js": 272,
	"./uz.js": 273,
	"./vi": 274,
	"./vi.js": 274,
	"./x-pseudo": 275,
	"./x-pseudo.js": 275,
	"./yo": 276,
	"./yo.js": 276,
	"./zh-cn": 277,
	"./zh-cn.js": 277,
	"./zh-hk": 278,
	"./zh-hk.js": 278,
	"./zh-tw": 279,
	"./zh-tw.js": 279
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.7fd2eef.jpg";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.a71ebd3.jpg";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.9689484.jpg";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.81d64d5.jpg";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.4deca14.jpg";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.1bf1677.jpg";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.5d4edce.jpg";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.dc89858.jpg";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.8fbd5b6.jpg";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.5798e6c.jpg";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.e8a40d4.jpg";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.a24f46f.jpg";

/***/ }),
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(697),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(727),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(702),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(694),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(704),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(726),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(680),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(700),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(725),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(706),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(684),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(683),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(696),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(699),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(698),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(685),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(686),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(687),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(688),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(689),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(690),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(691),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(692),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(701),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-idea-page"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "big-idea"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": this.$root.profile.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v(_vm._s(this.$root.profile.firstname + ' ' + this.$root.profile.surname))]), _vm._v(" "), _c('span', {
    staticClass: "reputation"
  }, [_vm._v(_vm._s(this.$root.userrep['.value']))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(this.$root.profile.jobtitle))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(this.$root.profile.location))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('label', [_vm._v("(Optional) Do you have a big idea for Africa " + _vm._s(this.$root.profile.firstname) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple"
  }, [_vm._v("View Example")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.bigIdea),
      expression: "bigIdea",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "rows": "4",
      "placeholder": "My big idea for africa is..."
    },
    domProps: {
      "value": (_vm.bigIdea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bigIdea = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "group-chat-person link",
    attrs: {
      "to": '/user/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(_vm.user.profileimg === 'default') ? _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.user.profileimg
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.firstname + ' ' + _vm.user.surname))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.remove($event)
      }
    }
  }, [_vm._v("Remove")])])
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "register"
    }
  }, [_vm._v("Sign Up")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [_c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      error: _vm.hasEmailError
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.emailMessage
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keydown": _vm.resetError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      error: _vm.hasPasswordError
    },
    attrs: {
      "type": "password",
      "pattern": ".{6,}",
      "placeholder": _vm.passwordMessage
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": _vm.resetError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "link green",
    attrs: {
      "to": "forgot-password"
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-three active",
    attrs: {
      "type": "submit",
      "value": "Log In"
    }
  })], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link navy",
    attrs: {
      "to": "terms"
    }
  }, [_vm._v("Terms & Conditions")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Log In To PEI ex"), _c('span', [_vm._v("Change")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [(_vm.presence) ? _c('span', {
    class: {
      'online': _vm.online['.value']
    },
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.user.firstname))]) : _vm._e(), (_vm.showDeli) ? _c('i', [_vm._v(_vm._s(_vm.deli) + " ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body",
    attrs: {
      "id": "chatter"
    }
  }, _vm._l((_vm.messages), function(message, id) {
    return _c('message', {
      key: id,
      attrs: {
        "message": message,
        "index": id,
        "allmessages": _vm.messages
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "admin bump-header"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h1', [_vm._v("No of Users:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.noOfUsers))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h1', [_vm._v("No of Users ONLINE:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.onlineUsers))])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('header-bar'), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "rep-diagram"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(this.$root.profile.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": this.$root.profile.profileimg
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("=")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', [_vm._v("Invite people that love to make things happen with your unique URL and earn +5 reputation when they sign up.")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": 'https://share.pei.exchange/' + this.$root.profile.slug
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-square facebook",
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=https%3A//share.pei.exchange/' + this.$root.profile.slug,
      "target": "_blank"
    }
  }, [_vm._v("Invite Over Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-square twitter",
    attrs: {
      "href": 'https://twitter.com/home?status=I\'ve%20just%20created%20an%20account%20on%20PEI%20exCHANGE,%20why%20not%20join%20me%20in%20supporting%20African%20development?%20https%3A//share.pei.exchange/' + this.$root.profile.slug,
      "target": "_blank"
    }
  }, [_vm._v("Invite Over Twitter")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-square email",
    attrs: {
      "href": 'mailto:?&subject=Join me on PEI exCHANGE&body=Hello,%0A%0AI\'ve%20just%20created%20an%20account%20on%20PEI%20exCHANGE.%0A%0Ahttps%3A//share.pei.exchange/' + this.$root.profile.slug + '%0A',
      "target": "_blank"
    }
  }, [_vm._v("Invite Over Email")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-circle"
  }, [_c('span', [_vm._v("+5")])])
}]}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-display-three",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemData.img
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.itemData.name))])])])
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "link-profile",
    attrs: {
      "to": '/user/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(_vm.user.profileimg === 'default') ? _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.user.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h5', [_vm._v(_vm._s(_vm.user.firstname + ' ' + _vm.user.surname))]), _vm._v(" "), _c('span', {
    staticClass: "job"
  }, [_vm._v(_vm._s(_vm.user.jobtitle)), _c('br'), _vm._v(_vm._s(_vm.user.organisation))])])])
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-display-one"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemData.img
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.itemData.name))])])
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copypage about"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("About Us")]), _vm._v(" "), _c('p', [_vm._v("The PEI exChange is the first online matching platform for all those passionate about African development.")]), _vm._v(" "), _c('p', [_vm._v("Based on user-identified criteria, including countries and regions of focus, industries, skills and experience, the PEI exChange provides personalised matches to help make your ‘Big Ideas for Africa’ a reality.")]), _vm._v(" "), _c('p', [_vm._v("Whatever it is – a charitable project, a business plan or an academic proposal – the PEI exChange makes it possible to connect with the right people, exchange ideas and knowledge and build networks to support your Big Ideas.")]), _vm._v(" "), _c('p', [_vm._v("We want to help you collaborate and innovate and stimulate. Wherever you are and whatever you need, the PEI exChange connects you to Africa.")]), _vm._v(" "), _c('p', [_vm._v("Join today and let’s drive real change for African development.")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("The PEI exChange is delivered by the Planet Earth Institute (PEI), and charity and NGO working for the scientific independence of Africa.")])])])])
}]}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-display-two"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemData.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.itemData.region) + " Africa"), _c('span', {
    staticClass: "highlighted"
  }, [_vm._v(_vm._s(_vm.itemData.name))])])])])
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('header-bar'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("Big Ideas Map - Coming soon!")]), _vm._v(" "), _c('p', [_vm._v("Share and promote, connect with and contribute to projects and initiatives on the ground in Africa – exchange ideas, and drive change for Africa")])])])])
}]}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matches"
  }, [_c('header-bar'), _vm._v(" "), (!_vm.uiHideInstructions) ? _c('section', {
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "vertical-align"
  }, [_c('h3', [_vm._v("You've been matched with these people based on focus areas, skills and regions of interest.")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.hideInstructions
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "filter",
    class: {
      noinstructions: _vm.uiHideInstructions
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "matches"
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(user, key) {
      return _c('user-box', {
        key: key,
        attrs: {
          "userid": user
        }
      })
    }))
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('p', [_vm._v("Ordered By Most Recent")])])
}]}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [_c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Connect, match, chat and build networks instantly within a global community passionate about Africa. Share your big ideas for African development, exchange skills, expertise and let's make change happen together.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      error: _vm.hasError
    },
    attrs: {
      "type": "email",
      "placeholder": "someone@example.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "type": "submit",
      "value": "Create Account"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "feedback"
  }, [_vm._v(_vm._s(_vm.message))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link navy",
    attrs: {
      "to": "terms"
    }
  }, [_vm._v("Terms & Conditions")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Exchange ideas, "), _c('span', {
    staticStyle: {
      "color": "#1AAD8F"
    }
  }, [_vm._v("drive change for Africa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [_c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      success: _vm.isSuccess, error: _vm.hasError
    },
    attrs: {
      "type": "password",
      "pattern": ".{6,}",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.confirmPassword),
      expression: "confirmPassword",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      success: _vm.isSuccess, error: _vm.hasError
    },
    attrs: {
      "type": "password",
      "pattern": ".{6,}",
      "placeholder": "Confirm Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "type": "submit",
      "value": "Set Password"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "feedback"
  }, [_vm._v(_vm._s(_vm.message))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link navy",
    attrs: {
      "to": "terms"
    }
  }, [_vm._v("Terms & Conditions")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("Great, let's keep your")]), _vm._v(" account safe")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-basics"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-one active",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Log In")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "long-form"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("First name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.firstname),
      expression: "$parent.firstname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. John",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.firstname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Last name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.surname),
      expression: "$parent.surname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Smith",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.surname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where do you work?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.organisation),
      expression: "$parent.organisation",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Example PLC",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.organisation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.organisation = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Sector:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.sector),
      expression: "$parent.sector"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.sector = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _c('option', [_vm._v("NGO")]), _vm._v(" "), _c('option', [_vm._v("Students")]), _vm._v(" "), _c('option', [_vm._v("Academia")]), _vm._v(" "), _c('option', [_vm._v("Researchers")]), _vm._v(" "), _c('option', [_vm._v("Private Sector")]), _vm._v(" "), _c('option', [_vm._v("Government")]), _vm._v(" "), _c('option', [_vm._v("Development Workers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where are you currently based?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.location),
      expression: "$parent.location",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. London"
    },
    domProps: {
      "value": (_vm.$parent.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.location = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("What's your job title?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.jobtitle),
      expression: "$parent.jobtitle",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Operations Manager",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.jobtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.jobtitle = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four register",
    class: {
      active: _vm.formComplete
    },
    attrs: {
      "id": "next"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_vm._v("Next")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Tell us a bit more about you, your work and areas of interest.")])])])])
}]}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-photo"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-one active",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Log In")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-4 col-4"
  }, [_c('profile-image')], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change Information")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Add a picture to your profile.")]), _vm._v(" The most popular profiles usually have images.")])])])])
}]}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "focus-area"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "focus-areas",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Learn about reputation")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Choose up to "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("five")]), _vm._v(" focus areas you currently work or have expertise in.")])])])])
}]}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "region"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Which area(s) of Africa do you want to make change happen in?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search for a country...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.CentralCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showCen
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showCen')
      }
    }
  }, [_vm._v("Central Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCen),
      expression: "showCen"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.CentralCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.NorthCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showNor
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showNor')
      }
    }
  }, [_vm._v("North Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNor),
      expression: "showNor"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.NorthCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.EastCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showEas
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showEas')
      }
    }
  }, [_vm._v("East Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEas),
      expression: "showEas"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.EastCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.SouthCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showSou
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showSou')
      }
    }
  }, [_vm._v("South Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSou),
      expression: "showSou"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.SouthCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.WestCountries.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showWes
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showWes')
      }
    }
  }, [_vm._v("West Africa")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWes),
      expression: "showWes"
    }],
    staticClass: "toggle"
  }, _vm._l((_vm.WestCountries), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "countries",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change focus area")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), (_vm.showTip) ? _c('p', {
    staticClass: "tip"
  }, [_vm._v("(Optional) You can choose as many regions as you like.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "your-skills"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search Skills...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.govAndIntDevSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showGov
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showGov')
      }
    }
  }, [_vm._v("Governance and International Development")]), _vm._v(" "), (_vm.showGov) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.govAndIntDevSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.commsSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showCom
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showCom')
      }
    }
  }, [_vm._v("Communications")]), _vm._v(" "), (_vm.showCom) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.commsSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.businessSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showBus
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showBus')
      }
    }
  }, [_vm._v("Business")]), _vm._v(" "), (_vm.showBus) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.businessSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.designSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showDes
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showDes')
      }
    }
  }, [_vm._v("Design and Creativity")]), _vm._v(" "), (_vm.showDes) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.designSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.leadershipSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showLea
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showLea')
      }
    }
  }, [_vm._v("Leadership and Management")]), _vm._v(" "), (_vm.showLea) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.leadershipSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.analyticSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showAna
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showAna')
      }
    }
  }, [_vm._v("Analysis and Research")]), _vm._v(" "), (_vm.showAna) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.analyticSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.techSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showTec
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showTec')
      }
    }
  }, [_vm._v("Technical and Information Skills")]), _vm._v(" "), (_vm.showTec) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.techSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.legalSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showLeg
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showLeg')
      }
    }
  }, [_vm._v("Legal")]), _vm._v(" "), (_vm.showLeg) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.legalSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stemSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showSte
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showSte')
      }
    }
  }, [_vm._v("STEM (science, technology, engineering and mathematics)")]), _vm._v(" "), (_vm.showSte) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.stemSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Choose area(s) of Africa")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Choose between "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("three")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ten")]), _vm._v(" of your skills you'd like to share. ")])
}]}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-idea-page"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "big-idea"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(this.$root.profilereg.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": this.$root.profilereg.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v(_vm._s(this.$root.profilereg.firstname + ' ' + this.$root.profilereg.surname))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(this.$root.profilereg.jobtitle))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(this.$root.profilereg.location))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('label', [_vm._v("(Optional) Do you have a big idea for Africa " + _vm._s(this.$root.profilereg.firstname) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addExample($event)
      }
    }
  }, [_vm._v("View Example")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.bigIdea),
      expression: "bigIdea",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "bigIdea",
      "rows": "4",
      "placeholder": "My big idea for africa is..."
    },
    domProps: {
      "value": (_vm.bigIdea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bigIdea = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }, [_vm._v(_vm._s(this.bigIdea))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change your skills")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skills-want"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._m(0), _vm._v(" "), (this.$parent.bigIdea) ? _c('p', {
    staticClass: "idea"
  }, [_vm._v("\"" + _vm._s(this.$parent.bigIdea) + "\"")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search Skills...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.govAndIntDevSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showGov
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showGov')
      }
    }
  }, [_vm._v("Governance and International Development")]), _vm._v(" "), (_vm.showGov) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.govAndIntDevSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.commsSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showCom
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showCom')
      }
    }
  }, [_vm._v("Communications")]), _vm._v(" "), (_vm.showCom) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.commsSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.businessSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showBus
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showBus')
      }
    }
  }, [_vm._v("Business")]), _vm._v(" "), (_vm.showBus) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.businessSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.designSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showDes
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showDes')
      }
    }
  }, [_vm._v("Design and Creativity")]), _vm._v(" "), (_vm.showDes) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.designSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.leadershipSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showLea
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showLea')
      }
    }
  }, [_vm._v("Leadership and Management")]), _vm._v(" "), (_vm.showLea) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.leadershipSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.analyticSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showAna
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showAna')
      }
    }
  }, [_vm._v("Analysis and Research")]), _vm._v(" "), (_vm.showAna) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.analyticSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.techSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showTec
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showTec')
      }
    }
  }, [_vm._v("Technical and Information Skills")]), _vm._v(" "), (_vm.showTec) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.techSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.legalSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showLeg
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showLeg')
      }
    }
  }, [_vm._v("Legal")]), _vm._v(" "), (_vm.showLeg) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.legalSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stemSkills.length) ? _c('div', [_c('h3', {
    class: {
      'active': _vm.showSte
    },
    on: {
      "click": function($event) {
        _vm.toggleGroup('showSte')
      }
    }
  }, [_vm._v("STEM (science, technology, engineering and mathematics)")]), _vm._v(" "), (_vm.showSte) ? _c('div', {
    staticClass: "toggle"
  }, _vm._l((_vm.stemSkills), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "skills",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  })) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change your Big Idea")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Choose between "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("three")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ten")]), _vm._v(" skills you need to make your big idea happen.")])
}]}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-circle plus"
  }, [(_vm.index == 3 && _vm.total > 4) ? _c('span', [_vm._v("+" + _vm._s(_vm.total - 3))]) : (_vm.user.profileimg === 'default') ? _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.user.profileimg
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copypage how-it-works"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("How it works")]), _vm._v(" "), _c('h3', [_vm._v("PEI exChange - Exchange ideas, drive change for Africa")]), _vm._v(" "), _c('p', [_vm._v("The first matching platform for people committed to African development")]), _vm._v(" "), _c('p', [_vm._v("The exChange is a growing online network of people truly passionate about African development.")]), _vm._v(" "), _c('p', [_vm._v("Get matched with people based on shared geographic, industrial focuses and specialisms. Connect, chat and exchange knowledge to make your Big Ideas for Africa a reality. Showcase your project, whatever its stage, and get recognition and exposure.")]), _vm._v(" "), _c('h4', [_vm._v("How the exChange works:")])])])])
}]}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v("Our Terms & Conditions")])])
}]}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "keep-alive": "",
      "thisuser": this.$parent.user,
      "personality": this.$parent.profile.personality,
      "favourites": this.$parent.profile.favourites
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "mobile-nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-matches",
    attrs: {
      "to": "/matches"
    }
  }, [_vm._v("Matches")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-everyone",
    attrs: {
      "to": "/everyone"
    }
  }, [_vm._v("Everyone")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-chats notify",
    attrs: {
      "to": "/chats"
    }
  }, [_vm._v("Chats")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "fg-type link-mobile-nav link-favourites",
    attrs: {
      "to": "/favourites"
    }
  }, [_vm._v("Favourites")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-basics"
  }, [_c('header-bar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "long-form"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("First name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.firstname),
      expression: "firstname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "John",
      "required": ""
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Last name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.surname),
      expression: "surname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Smith",
      "required": ""
    },
    domProps: {
      "value": (_vm.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where do you work?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.organisation),
      expression: "organisation",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Example PLC",
      "required": ""
    },
    domProps: {
      "value": (_vm.organisation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organisation = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Organisation website:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.website),
      expression: "website",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "url",
      "placeholder": "example.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.website = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where are you currently based?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.location),
      expression: "location",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "London"
    },
    domProps: {
      "value": (_vm.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.location = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("What's your job title?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.jobtitle),
      expression: "jobtitle",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Operations Manager",
      "required": ""
    },
    domProps: {
      "value": (_vm.jobtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.jobtitle = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Tell us a bit more about you, your work and areas of interest.")])])])])
}]}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "page-empty"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-align"
  }, [_c('h4', [_vm._v("Coming soon! Projects is a new feature that will enable people to work together to create a sustainable Africa.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round green",
    on: {
      "click": _vm.testMailchimp
    }
  }, [_vm._v("Test Mailchimp")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round green",
    on: {
      "click": _vm.addData
    }
  }, [_vm._v("Add Data")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.testVariable))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link) ? _c('router-link', {
    staticClass: "list-box-item",
    class: {
      notify: _vm.unread
    },
    attrs: {
      "to": _vm.link
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nano"
  }, [_vm._v(_vm._s(_vm.message)), _c('span', [_vm._v(_vm._s(_vm.dateShow))])])]) : _c('div', {
    staticClass: "list-box-item",
    class: {
      notify: _vm.unread
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nano"
  }, [_vm._v(_vm._s(_vm.message)), _c('span', [_vm._v(_vm._s(_vm.dateShow))])])])
},staticRenderFns: []}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-list"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('input', {
    staticClass: "search",
    attrs: {
      "placeholder": "Search Chats..."
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "link-simple",
    attrs: {
      "to": "/chats/new"
    }
  }, [_vm._v("New")])], 1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.chats), function(chat, id) {
    return _c('item', {
      key: chat['.key'],
      attrs: {
        "after": chat.showAfter,
        "id": chat['.key']
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path === '/matches' || _vm.$route.path === '/favourites') ? _c('div', {
    staticClass: "col-3"
  }, [_c('router-link', {
    staticClass: "profile-box",
    attrs: {
      "to": 'user/' + _vm.userData.slug
    }
  }, [_c('div', {
    staticClass: "image-profile"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  }), _vm._v(" "), (_vm.metadisplay) ? _c('div', {
    staticClass: "btn-remove",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.removeFavourite(_vm.userid)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/matches') ? _c('div', {
    staticClass: "btn-remove",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.removeMatch(_vm.userid)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info",
    attrs: {
      "data-userid": _vm.userid
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.userData.firstname + ' ' + _vm.userData.surname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userData.jobtitle) + ", " + _vm._s(_vm.userData.organisation))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Based in " + _vm._s(_vm.userData.location))])])])], 1) : (_vm.$route.path === '/everyone') ? _c('div', {
    staticClass: "col-2"
  }, [_c('router-link', {
    staticClass: "profile-box small",
    attrs: {
      "to": 'user/' + _vm.userData.slug
    }
  }, [_c('div', {
    staticClass: "image-profile"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info",
    attrs: {
      "data-userid": _vm.userid
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.userData.firstname + ' ' + _vm.userData.surname))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.userData.jobtitle) + ", " + _vm._s(_vm.userData.organisation))])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.user.firstname + ' ' + _vm.user.surname))]), _vm._v(" "), (_vm.online['.value']) ? _c('span', {
    staticClass: "active"
  }, [_vm._v("Online Now")]) : _c('span', [_vm._v("Offline")])])
},staticRenderFns: []}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.process === 'signup') ? _c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link link-profile"
  }, [_c('span', {
    staticClass: "image-circle"
  }, [(this.$root.profilereg.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": this.$root.profilereg.profileimg
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(this.$root.profilereg.firstname + ' ' + this.$root.profilereg.surname))])])])]) : _c('header', [_c('div', {
    staticClass: "grid-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/matches"
    }
  }, [_vm._v("Matches")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/everyone"
    }
  }, [_vm._v("Everyone")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/favourites"
    }
  }, [_vm._v("Favourites")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projects")])], 1)])]), _vm._v(" "), (this.$root.profile.admin) ? _c('nav', {
    staticClass: "admin"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/admin/overview"
    }
  }, [_vm._v("Stats")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/admin/site"
    }
  }, [_vm._v("Site Admin")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/admin/reports"
    }
  }, [_vm._v("Reports")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/tests"
    }
  }, [_vm._v("Tests")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link link-profile",
    on: {
      "click": _vm.toggleFunctions
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(this.$root.profile.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": this.$root.profile.profileimg
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "name",
    attrs: {
      "data-userid": this.$root.user.uid
    }
  }, [_vm._v(_vm._s(this.$root.profile.firstname + ' ' + this.$root.profile.surname))])]), _vm._v(" "), _c('a', {
    staticClass: "link-notification",
    class: {
      notify: _vm.unreadNotifications
    },
    on: {
      "click": _vm.toggleNotifications
    }
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-notification",
    class: {
      notify: _vm.chatNotify
    },
    attrs: {
      "to": "/chats"
    }
  }, [_vm._v("Chats")]), _vm._v(" "), _c('div', {
    staticClass: "grid-container",
    attrs: {
      "id": "notifications"
    }
  }, [_c('div', {
    staticClass: "list-box",
    class: {
      active: _vm.notificationsActive
    }
  }, [_vm._l((this.$root.notifications), function(item) {
    return _c('notification-item', {
      key: item['.key'],
      attrs: {
        "senderid": item.from,
        "message": item.content,
        "when": item.when,
        "link": item.link,
        "unread": item.unread
      }
    })
  }), _vm._v(" "), (_vm.showTip) ? _c('span', {
    staticClass: "tip"
  }, [_vm._v("No notifications")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "grid-container profile-functions",
    attrs: {
      "id": "profile-functions"
    }
  }, [_c('div', {
    staticClass: "list-box profile",
    class: {
      active: _vm.functionsActive
    }
  }, [_c('div', {
    staticClass: "list-box-item"
  }, [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": {
        name: 'User Profile',
        params: {
          slug: this.$root.profile.slug
        }
      }
    }
  }, [_vm._v("View Profile")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-box-item"
  }, [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/share"
    }
  }, [_vm._v("Share PEI.exCHANGE")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list-box-item"
  }, [_c('router-link', {
    staticClass: "link-simple fg-type",
    attrs: {
      "to": "/logout"
    }
  }, [_vm._v("Logout")])], 1)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interested"
  }, [_c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.preReg), function(row) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_vm._v("\n          " + _vm._s(row.email) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_vm._v("\n          " + _vm._s(_vm.formatDate(row.when)) + "\n        ")])])
  })], 2)]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h3', [_vm._v("BCC Combined Link:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.bccLink
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bccLink) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h3', [_vm._v("Email:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h3', [_vm._v("When:")])])])
}]}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.setUpFileUploader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-photo-picker"
  }, [_c('div', {
    attrs: {
      "id": "croppie"
    }
  }), _vm._v(" "), (!_vm.image) ? _c('div', {
    on: {
      "click": _vm.addPhoto
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Upload Photo")])]) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('p', {
    on: {
      "click": _vm.addPhoto
    }
  }, [_vm._v("Change Photo")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-circle"
  }, [_c('img'), _vm._v(" "), _c('span', {}, [_vm._v("800 x 800")])])
}]}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message.user == this.$root.user.uid) ? _c('div', {
    staticClass: "message mine"
  }, [(!_vm.continuedMessage) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), (!_vm.continuedMessage) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_vm._v(_vm._s(_vm.message.content))]), _vm._v(" "), (!_vm.finalMessage) ? _c('div', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.from.firstname + ' ' + _vm.from.surname))]), _vm._v(" "), _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  })]) : _vm._e()]) : _c('div', {
    staticClass: "message"
  }, [(!_vm.continuedMessage) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), (!_vm.continuedMessage) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_vm._v(_vm._s(_vm.message.content))]), _vm._v(" "), (!_vm.finalMessage) ? _c('div', {
    staticClass: "author"
  }, [_c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.from.firstname + ' ' + _vm.from.surname))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.chat.lastUpdated >= _vm.after) ? _c('router-link', {
    class: {
      'chat-item': true, 'multiple': (_vm.members.length > 2), 'notify': (_vm.unreads['.value'] > 0)
    },
    attrs: {
      "to": '/chats/' + _vm.id
    }
  }, [_c('div', {
    on: {
      "click": _vm.read
    }
  }, [(_vm.members.length > 2) ? _c('div', {
    staticClass: "image-holder"
  }, _vm._l((_vm.members), function(member, id) {
    return (id < 4) ? _c('profile-picture', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "index": id,
        "total": _vm.members.length
      }
    }) : _vm._e()
  })) : _c('div', _vm._l((_vm.members), function(member, id) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('profile-picture', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.members.length > 2) ? _c('h5', _vm._l((_vm.members), function(member, id) {
    return _c('first-name-list', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "deli": ',',
        "showDeli": (id + 1 < _vm.members.length)
      }
    })
  })) : _c('h5', _vm._l((_vm.members), function(member, id) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('full-name-list', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })), _vm._v(" "), (_vm.unreads['.value'] > 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.unreads['.value']))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.chat.lastUpdated, 'h:MMtt')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.chat.lastMessage))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentStep === 1 || !_vm.$route.params.step) ? _c('register-step-1') : (_vm.currentStep === 2) ? _c('register-step-2') : (_vm.currentStep === 3) ? _c('register-step-3') : (_vm.currentStep === 4) ? _c('register-step-4') : (_vm.currentStep === 5) ? _c('register-step-5') : (_vm.currentStep === 6) ? _c('register-step-6') : (_vm.currentStep === 7) ? _c('register-step-7') : (_vm.currentStep === 8) ? _c('register-step-8') : (_vm.currentStep === 9) ? _c('register-step-9') : (_vm.currentStep === 10) ? _c('register-step-10') : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-complete"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Thanks " + _vm._s(this.$root.profile.firstname) + "!")]), _vm._v(" "), _c('p', [_vm._v("You're profile is now complete.")]), _vm._v(" "), _c('p', [_vm._v("You can match, connect, exchange and make big ideas for Africa happen!")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "to": "/matches"
    }
  }, [_vm._v("Discover your matches")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chats"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "chat"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('list', {
    attrs: {
      "chats": _vm.chats
    }
  }), _vm._v(" "), (_vm.current && _vm.current !== 'new') ? _c('conversation', {
    attrs: {
      "id": _vm.current,
      "after": _vm.chat.showAfter
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.params.id === 'new') ? _c('new') : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-new"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('label', [_vm._v("To:")]), _vm._v(" "), _vm._l((_vm.members), function(member, index) {
    return _c('div', {
      staticClass: "btn-item-added"
    }, [_vm._v("\n      " + _vm._s(member.firstname + ' ' + member.surname) + "\n      "), _c('a', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.remove(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "type": "text",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    class: {
      'input-options': true, 'active': _vm.results.length
    }
  }, _vm._l((_vm.results), function(user) {
    return (user['.key'] !== _vm.$root.user.uid) ? _c('li', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          _vm.add(user)
        }
      }
    }, [_c('div', {
      staticClass: "image-circle"
    }, [_c('img', {
      attrs: {
        "src": user.profileimg
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.firstname + ' ' + user.surname))])]) : _vm._e()
  }))])], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message",
    attrs: {
      "type": "text",
      "placeholder": "Type a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.send($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [(!_vm.added) ? _c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "large",
    staticStyle: {
      "font-size": "1.28em",
      "padding-bottom": "13px"
    }
  }, [_vm._v("The first ever matching platform for people passionate about African development.")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "#1ba4db",
      "font-family": "'Apercu-medium', sans-serif"
    }
  }, [_vm._v("Sign up for early access:")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "someone@example.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-two active",
    staticStyle: {
      "background-position": "center 553px"
    },
    attrs: {
      "type": "submit",
      "value": "Yes, I'm In!"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#7B7E80",
      "opacity": "0.6",
      "position": "relative",
      "top": "16px"
    }
  }, [_vm._v("We promise to never spam you!")])])]) : (_vm.added) ? _c('div', {
    staticClass: "left-panel-centre"
  }, [_c('h1', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Thanks!")]), _vm._v(" We'll email you when our registration process opens.")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_c('h3', {
    staticStyle: {
      "color": "#1ba4db"
    }
  }, [_vm._v("#BigIdeasforAfrica")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link blue",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About PEI exChange")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticStyle: {
      "color": "#1ba4db"
    }
  }, [_vm._v("Join us as we build "), _c('br'), _c('span', {
    staticStyle: {
      "color": "#00AE8F"
    }
  }, [_vm._v("PEI")]), _vm._v(" ex"), _c('span', {
    staticStyle: {
      "color": "#327CA2"
    }
  }, [_vm._v("Change")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [(_vm.presence) ? _c('span', {
    class: {
      'active': _vm.online['.value']
    },
    staticStyle: {
      "display": "inline"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.user.firstname)), (_vm.showDeli) ? _c('i', [_vm._v(_vm._s(_vm.deli))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "overlay-alert"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "alert-box"
  }, [_c('h4', [_vm._v("Block & Report " + _vm._s(_vm.firstname + ' ' + _vm.surname) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "btn-remove",
    on: {
      "click": _vm.closeOverlay
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_c('label', [_vm._v("Tell us why you want to report " + _vm._s(_vm.firstname) + ":")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.reportReason),
      expression: "reportReason",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "modal",
    attrs: {
      "rows": "6",
      "placeholder": 'I want to report ' + _vm.firstname + ' because...'
    },
    domProps: {
      "value": (_vm.reportReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportReason = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.closeOverlay
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn active",
    on: {
      "click": _vm.reportUser
    }
  }, [_vm._v("Block & Report")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.data), function(item, key) {
    return _c('swiper-slide', {
      key: key
    }, [_c('skill', {
      attrs: {
        "itemid": key
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-next",
    slot: "button-next"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-options"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "link-icon-after link-add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.invite = true
      }
    }
  }, [_vm._v("Add People To Chat")])]), _vm._v(" "), (_vm.$parent.members.length < 3) ? _c('div', _vm._l((_vm.$parent.members), function(member) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('single-member', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })) : _c('div', {
    staticClass: "group-chat-holder"
  }, _vm._l((_vm.$parent.members), function(member) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('multiple-members', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "admin-options"
  }, [_c('h5', [_vm._v("Options")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteChat($event)
      }
    }
  }, [_vm._v("Delete Chat")])]), _vm._v(" "), (_vm.invite) ? _c('invite', {
    attrs: {
      "chatID": _vm.chatID
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.data), function(item, key) {
    return _c('swiper-slide', {
      key: key
    }, [_c('div', {
      staticClass: "btn-item-added"
    }, [_vm._v(_vm._s(item.name)), _c('a', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.removeTag(item.id, item.name)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-next",
    slot: "button-next"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matches"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('h1', [_vm._v("Delete a user:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userid),
      expression: "userid",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "User UID",
      "required": ""
    },
    domProps: {
      "value": (_vm.userid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userid = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-two active",
    staticStyle: {
      "margin-top": "50px",
      "background-position": "50% 553px"
    },
    attrs: {
      "type": "submit",
      "value": "Delete User"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.deleteUser($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_vm._v("\n    " + _vm._s(_vm.userdata) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [_c('div', {
    staticClass: "left-panel-centre"
  }, [_c('h1', [_vm._v("Logging out...")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
}]}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.chat.lastUpdated && _vm.chat.lastUpdated >= _vm.after) ? _c('div', [_c('div', {
    staticClass: "chat-conversation"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.members.length > 2) ? [_c('h5', _vm._l((_vm.members), function(member, id) {
    return _c('first-name', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "deli": ',',
        "presence": true,
        "showDeli": (id + 1 < _vm.members.length)
      }
    })
  }))] : _vm._l((_vm.members), function(member, id) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('full-name', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "presence": true
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "id": "conversation"
    }
  }, _vm._l((_vm.messages), function(message, id) {
    return (message.createdAt >= _vm.after) ? _c('message', {
      key: id,
      attrs: {
        "message": message,
        "index": id,
        "allmessages": _vm.messages
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message",
    attrs: {
      "type": "text",
      "placeholder": "Type a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.send($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('options', {
    attrs: {
      "chatID": _vm.id
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Login")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [(_vm.resetComplete) ? _c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "left-panel-centre"
  }, [_c('h1', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Forgot your password?"), _c('br')]), _vm._v("We'll email you a new one.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.forgotPassword($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "value": "you@youremail.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-three active",
    attrs: {
      "type": "submit",
      "value": "Send Link"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link navy",
    attrs: {
      "to": "terms"
    }
  }, [_vm._v("Terms & Conditions")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Thanks!")]), _vm._v(" A link to reset your password is on it's way.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "profile-header",
    class: {
      noidea: !_vm.hasIdea
    },
    style: ('background-image: url(' + _vm.background + ');')
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(_vm.user.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.user.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.firstname + ' ' + _vm.user.surname))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.user.jobtitle)), _c('br'), _vm._v(_vm._s(_vm.user.organisation))]), _vm._v(" "), _c('h4', [_vm._v("Based in " + _vm._s(_vm.user.location))]), _vm._v(" "), (_vm.currentUser) ? _c('router-link', {
    staticClass: "btn btn-round green",
    attrs: {
      "to": {
        name: 'Edit Profile',
        params: {
          area: 'user-meta'
        }
      }
    }
  }, [_vm._v("Edit Profile")]) : _vm._e(), _vm._v(" "), (!_vm.currentUser) ? _c('a', {
    staticClass: "btn btn-round green",
    on: {
      "click": _vm.openChat
    }
  }, [_vm._v("Chat To " + _vm._s(_vm.user.firstname))]) : _vm._e(), _vm._v(" "), (!_vm.currentUser) ? _c('a', {
    staticClass: "btn-star",
    class: {
      active: _vm.isFavourited
    },
    on: {
      "click": _vm.favouriteUser
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.currentUser) ? _c('a', {
    staticClass: "btn-more",
    on: {
      "click": _vm.openOptions
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _c('span', {
    staticClass: "circle"
  }), _c('span', {
    staticClass: "circle"
  })]) : _vm._e()], 1)]), _vm._v(" "), (_vm.hasIdea) ? _c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.bigidea))]), _vm._v(" "), (_vm.currentUser) ? _c('router-link', {
    staticClass: "btn btn-round green",
    attrs: {
      "to": {
        name: 'Edit Profile',
        params: {
          area: 'big-idea'
        }
      }
    }
  }, [_vm._v("Edit Big Idea")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Member since " + _vm._s(_vm.userJoined))])], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "profile-body"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-5"
  }, [(_vm.focusAreas) ? _c('h4', [_vm._v("Focus Area:")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.focusAreas), function(item, key) {
    return _c('focus-area', {
      key: key,
      attrs: {
        "itemid": key
      }
    })
  })), _vm._v(" "), (_vm.countries) ? _c('h4', {
    staticClass: "padding-top"
  }, [_vm._v("Regions of interest:")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.countries), function(item, key) {
    return _c('country', {
      key: key,
      attrs: {
        "itemid": key
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 shift-1"
  }, [_c('div', {
    staticClass: "skills-subsection"
  }, [(_vm.wantSkills) ? _c('h4', [_vm._v("Skills " + _vm._s(_vm.user.firstname) + " is looking for:")]) : _vm._e(), _vm._v(" "), (_vm.wantSkills) ? _c('div', {
    staticClass: "skills-holder"
  }, [_c('div', {
    staticClass: "skills-wrapper"
  }, [_c('slider', {
    attrs: {
      "data": _vm.wantSkills
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "skills-subsection"
  }, [(_vm.hasSkills) ? _c('h4', [_vm._v("Skills " + _vm._s(_vm.user.firstname) + " has:")]) : _vm._e(), _vm._v(" "), (_vm.hasSkills) ? _c('div', {
    staticClass: "skills-holder"
  }, [_c('div', {
    staticClass: "skills-wrapper"
  }, [_c('slider', {
    attrs: {
      "data": _vm.hasSkills
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), (!_vm.currentUser) ? _c('section', {
    staticClass: "profile-chat"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "chat-box",
    class: {
      active: _vm.chatActive
    }
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": _vm.toggleChat
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.profileimg
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "online"
  }, [_vm._v("Chat to " + _vm._s(_vm.user.firstname))])]), _vm._v(" "), _c('chat', {
    attrs: {
      "chats": _vm.chats,
      "userid": this.$route.params.uid
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message",
    attrs: {
      "type": "text",
      "placeholder": "Type a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.send($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showOptionsOverlay) ? _c('section', {
    staticClass: "overlay-dialogue binary",
    on: {
      "click": _vm.closeOptions
    }
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-align"
  }, [_c('h4', [_vm._v("Would you like to block or report " + _vm._s(_vm.user.firstname) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round red",
    on: {
      "click": _vm.blockUser
    }
  }, [_vm._v("Block " + _vm._s(_vm.user.firstname))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round red",
    on: {
      "click": _vm.blockAndReportUser
    }
  }, [_vm._v("Block & Report")])])])]) : _vm._e(), _vm._v(" "), (_vm.showBlockOverlay) ? _c('block-report', {
    attrs: {
      "userid": this.$route.params.uid,
      "firstname": _vm.user.firstname,
      "surname": _vm.user.surname
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "favourites"
  }, [_c('header-bar'), _vm._v(" "), (!_vm.uiHideInstructions) ? _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chunkArrayLength),
      expression: "chunkArrayLength"
    }],
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "vertical-align"
  }, [_c('h3', [_vm._v("These are all the people you've favourited. Chat now or start a conversation later.")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.hideInstructions
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), (_vm.chunkArrayLength) ? _c('section', {
    staticClass: "matches",
    class: {
      noinstructions: _vm.uiHideInstructions
    }
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(user, key) {
      return _c('user-box', {
        key: key,
        attrs: {
          "userid": user,
          "metadisplay": _vm.favourites
        }
      })
    }))
  }))]) : (!_vm.chunkArrayLength) ? _c('section', {
    staticClass: "page-empty"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-align"
  }, [_c('h4', [_vm._v("You haven't favourited anyone yet. View your "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Matches")]), _vm._v(" to find some interesting people.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-round green",
    attrs: {
      "to": "matches"
    }
  }, [_vm._v("View Matches")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [(_vm.presence) ? _c('span', {
    class: {
      'active': _vm.online['.value']
    },
    staticStyle: {
      "display": "inline"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.user.firstname + ' ' + _vm.user.surname)), (_vm.showDeli) ? _c('i', [_vm._v(_vm._s(_vm.deli))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "overlay-invite"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "list-side"
  }, [_c('h4', [_vm._v("Invite Matches To Conversation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search Matches...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-holder"
  }, _vm._l((_vm.results), function(user) {
    return (_vm.members[user['.key']] == undefined) ? _c('div', {
      class: {
        'list-item': true, 'active': _vm.invitationList.indexOf(user['.key']) !== -1
      },
      on: {
        "click": function($event) {
          _vm.addToList(user['.key'])
        }
      }
    }, [_c('div', {
      staticClass: "image-circle"
    }, [(user.profileimg === 'default') ? _c('img', {
      staticClass: "image-circle",
      attrs: {
        "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
      }
    }) : _c('img', {
      staticClass: "image-circle",
      attrs: {
        "src": user.profileimg
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.firstname + ' ' + user.surname))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "list-side"
  }, [_c('h4', [_vm._v("Invite someone else:")]), _vm._v(" "), _c('div', {
    staticClass: "form-holder"
  }, [_c('label', [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "modal",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "invite-bottom"
  }, [_c('a', {
    staticClass: "link-simple",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$parent.invite = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn bg-three active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.invite($event)
      }
    }
  }, [_vm._v("Invite")])])])])])
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link link-rep",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "rep-circle"
  }, [_vm._v("+3")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('span', [_vm._v("Enjoying your conversation?")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("Give " + _vm._s(_vm.user.firstname) + " +3 Reputation")])])])
},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "focus-area"
  }, [_c('header-bar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "focus-areas",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Choose up to "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("five")]), _vm._v(" focus areas you currently work or have expertise in.")])])])])
}]}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$route.params.area === 'user-meta') ? _c('user-meta') : (this.$route.params.area === 'big-idea') ? _c('big-idea') : (this.$route.params.area === 'focus-areas') ? _c('focus-areas') : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message.user == this.$root.user.uid) ? _c('div', {
    staticClass: "message mine",
    class: {
      first: !_vm.continuedMessage, continued: _vm.continuedMessage
    }
  }, [(_vm.showWhen) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), (_vm.showWhen) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.from.firstname) + ":")]), _vm._v("\n        " + _vm._s(_vm.message.content) + "\n    ")])]) : _c('div', {
    staticClass: "message notmine",
    class: {
      first: !_vm.continuedMessage, continued: _vm.continuedMessage
    }
  }, [(_vm.showWhen) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), (_vm.showWhen) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.from.firstname) + ":")]), _vm._v("\n        " + _vm._s(_vm.message.content) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "profile-header"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasIdea) ? _c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("Countries")]), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "profile-body"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-5"
  }, [(_vm.countries) ? _c('h4', [_vm._v("Regions of interest:")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.countries), function(item, key) {
    return _c('country', {
      key: key,
      attrs: {
        "itemid": key
      }
    })
  }))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "image-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  })])
}]}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "everyone"
  }, [_c('header-bar'), _vm._v(" "), (!_vm.uiHideInstructions) ? _c('section', {
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "vertical-align"
  }, [_c('h3', [_vm._v("This is everyone who has signed up to the PEI exChange. Tap to view their profile.")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.hideInstructions
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "filter",
    class: {
      noinstructions: _vm.uiHideInstructions
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chunkArray),
      expression: "chunkArray"
    }],
    staticClass: "matches"
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('user-row', {
      key: row,
      attrs: {
        "data": row
      }
    })
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "shift-1 col-4"
  })])
}]}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.itemclass === 'focus-areas') ? _c('div', {
    staticClass: "col-3",
    on: {
      "click": _vm.toggleItem
    }
  }, [_c('div', {
    staticClass: "picker-item",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemimg
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.itemname))])])])]) : (_vm.itemclass === 'skills') ? _c('div', {
    staticClass: "col-2",
    on: {
      "click": _vm.toggleItem
    }
  }, [_c('div', {
    staticClass: "picker-item small",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemimg
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.itemname))])])])]) : (_vm.itemclass === 'countries') ? _c('div', {
    staticClass: "col-2",
    on: {
      "click": _vm.toggleItem
    }
  }, [_c('div', {
    staticClass: "picker-item small",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemimg
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.itemname))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.data), function(user) {
    return _c('user-box', {
      key: user,
      attrs: {
        "userid": user
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(286);
module.exports = __webpack_require__(285);


/***/ })
],[742]);


// WEBPACK FOOTER //
// static/js/app.02dc9e0c99c35db174ad.js